<div class="d-flex align-items-center justify-content-between position-relative lead-toolbar-row" helpTarget="lead-detail-toolbar">
  <div class="d-flex align-items-center gap-3 lead-toolbar-left">
    <div class="d-flex align-items-center lead-tabs b-b-tabs position-relative">
      <ul class="nav nav-pills tools-tab-nav align-items-end" id="pills-tab" role="tablist" helpTarget="leads-activity">
        <li *ngFor="let tab of tabs; let i = index" class="nav-item cursor-pointer" role="presentation" (click)="onTabClick(i, tab.action)">
          <ng-container *ngFlag="tab.flag">
            <a
              [ngClass]="{ active: tabIndexValue === i }"
              [id]="'pills-' + tab.id + '-tab'"
              data-bs-toggle="pill"
              [attr.data-bs-target]="'#' + tab.id + leadTabIndex"
              role="tab"
              [attr.aria-controls]="tab.id + leadTabIndex"
              [attr.aria-selected]="tabIndexValue === i ? 'true' : 'false'">
              <img [src]="tab.icon" alt="" class="mr-2" />
              {{ tab.label }}
            </a>
          </ng-container>
        </li>
      </ul>
    </div>
    <button
      *ngIf="isMultipleLead && sameProjectDuplicateCount > 0"
      type="button"
      class="_outline-btn d-flex align-items-center gap-1"
      [class.has-duplicates]="isMultipleLead"
      pTooltip="Review possible duplicate leads and merge information"
      tooltipPosition="bottom"
      (click)="openDuplicateReview()">
      <i class="pi pi-clone f-12"></i>
      Mark Duplicate
      <span *ngIf="isMultipleLead" class="dup-badge">{{ sameProjectDuplicateCount || '' }}</span>
    </button>
    <ng-container *ngFor="let status of leadStatus; let i = index; let islast = last">
      <div class="d-flex flex-column" *ngIf="editLeadForm.controls['lead_status'].value == status.tag_name">
        <p
          class="_fw-600 activeTags f-14"
          [ngStyle]="{
            'background-color': editLeadForm.controls['lead_status'].value == status.tag_name ? status?.background_color : '',
          }">
          {{ status.tag_name }}
        </p>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="!isLeadEdit; else isEditEnable">
    <div class="d-flex align-items-center position-relative gap-2">
      <p>{{ lead_detail?.reassigned_old_lead == true ? 'Reassigned (Old Lead)' : '' }}</p>

      <div
        class="auto-save-pill"
        *ngIf="autoSaveEnabled && (autoSaveState === 'saving' || autoSaveState === 'error')"
        [class.is-error]="autoSaveState === 'error'"
        [pTooltip]="autoSaveError"
        tooltipPosition="bottom"
        aria-live="polite">
        <span class="auto-save-pill__spinner" *ngIf="autoSaveState === 'saving'"></span>
        <i class="pi pi-exclamation-triangle f-12" *ngIf="autoSaveState === 'error'"></i>
        <span>{{ autoSaveState === 'error' ? 'Auto save failed' : 'Auto save On' }}</span>
      </div>

      <ng-container *ngIf="isAllowEdit()">
        <!-- A round icon button in the toolbar's own language (_addNewlightBg),
             rather than a wide text pill wedged between the icon buttons. -->
        <button
          type="button"
          class="_addNewlightBg"
          *ngIf="canGenerateExternalEoi"
          (click)="openExternalEoiModal()"
          pTooltip="External EOI Link"
          tooltipPosition="bottom"
          aria-label="Generate a secure link for this buyer to complete the EOI form">
          <i class="fa-solid fa-link f-12"></i>
        </button>
        <button type="button" class="_addNew p-2" helpTarget="lead-detail-edit-toggle" (click)="isLeadEdit = true">
          <img [src]="common_images?.edit_icon" class="cursor-pointer" width="16px" />
        </button>
      </ng-container>
      <div
        class="contact_attempt mr-0"
        helpTarget="lead-detail-contact-attempt"
        (click)="is_follow = false; isComission = true"
        (clickOutside)="onClickOutSide($event)">
        <div pTooltip="Contact Attempted" tooltipPosition="bottom" class="tooltip"></div>
        <i class="pi pi-phone f-12 _fw-400"></i>
        <ul *ngIf="isComission">
          <li *ngFor="let opt of contactAttemptOptions" (click)="toggleCommissionType(opt.id)" [class.active]="commissionType?.includes(opt.id)">
            <div class="check_box" [class.active]="commissionType?.includes(opt.id)"></div>
            {{ opt.label }}
          </li>
        </ul>
        <div class="addition-note" *ngIf="commissionType?.includes('Called - Call Answered')">
          <div class="d-flex justify-content-between mb-2">
            <p class="_fw-600">Notes</p>
            <i class="pi pi-times _fw-600 primary-color f-12" (click)="hideNote()"></i>
            <!-- <p class="_fw-600 primary-color" (click)="hideNote()">Save & Close</p> -->
          </div>
          <textarea
            pInputTextarea
            spellcheck="true"
            autoresize="autoResize"
            [(ngModel)]="additional_notes"
            (ngModelChange)="onContactNoteChange()"
            style="min-height: 200px; border-radius: 8px !important; text-align: justify">
          </textarea>
        </div>
      </div>

      <button
        type="button"
        class="_view-btn p-2"
        helpTarget="lead-detail-follow-up"
        (click)="isComission = false; is_follow = true; getTaskStatusTypes()">
        <img [src]="images?.flag_icon" alt="" />
      </button>

      <app-lead-follow-up-popover
        [isVisible]="is_follow"
        [containerClass]="'is-follow-not-edit'"
        [helpTarget]="'lead-detail-follow-up-schedule'"
        [isPickDate]="is_pick_date"
        [minSelectableDate]="minSelectableDate"
        [timerOptions]="timer_options"
        [followUpTime]="follow_up_time"
        [activeOptionId]="follow_priority"
        (close)="closeFollowUpPanel()"
        (quickFollowUp)="onQuickFollowUpSelect($event)"
        (togglePickDate)="toggleFollowUpDatePicker()"
        (dateSelected)="selectDates($event)"
        (timeChanged)="followUp(true)"
        (followUpTimeChange)="setFollowUpTime($event)">
      </app-lead-follow-up-popover>
    </div>
  </ng-container>

  <ng-template #isEditEnable>
    <div class="d-flex align-items-center position-relative">
      <p class="mr-2">{{ lead_detail?.reassigned_old_lead == true ? 'Reassigned (Old Lead)' : '' }}</p>

      <div style="width: 180px" helpTarget="lead-detail-status-type">
        <ng-select
          [items]="status_type"
          bindLabel="tag_name"
          bindValue="tag_name"
          [searchable]="true"
          placeholder="Select Status Type"
          [clearable]="true"
          id="status_type"
          name="status_type"
          [(ngModel)]="lead_status_type">
          <ng-template ng-option-tmp let-item="item">
            <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
          </ng-template>
        </ng-select>
      </div>

      <button
        type="button"
        class="_view-btn mx-2 p-2"
        helpTarget="lead-detail-follow-up"
        (click)="is_follow = true; getTaskStatusTypes()"
        *ngIf="!mobToggle">
        <img [src]="images?.flag_icon" alt="" />
      </button>

      <!-- Was only in the view-mode toolbar above, so entering edit mode made it vanish — an
           agent mid-edit who wants to check or share the link had no way to get to it. -->
      <button
        type="button"
        class="_addNewlightBg mr-2"
        *ngIf="canGenerateExternalEoi"
        (click)="openExternalEoiModal()"
        pTooltip="External EOI Link"
        tooltipPosition="bottom"
        aria-label="Generate a secure link for this buyer to complete the EOI form">
        <i class="fa-solid fa-link f-12"></i>
      </button>
      <button type="button" class="_addNew p-2 mr-2" helpTarget="lead-detail-edit-toggle" (click)="isLeadEdit = false">
        <img [src]="common_images?.edit_icon" class="cursor-pointer" width="16px" />
      </button>

      <app-lead-follow-up-popover
        [isVisible]="is_follow"
        [containerClass]="'is-follow'"
        [helpTarget]="'lead-detail-follow-up-schedule-edit'"
        [isPickDate]="is_pick_date"
        [minSelectableDate]="minSelectableDate"
        [timerOptions]="timer_options"
        [followUpTime]="follow_up_time"
        [activeOptionId]="follow_priority"
        (close)="closeFollowUpPanel()"
        (quickFollowUp)="onQuickFollowUpSelect($event)"
        (togglePickDate)="toggleFollowUpDatePicker()"
        (dateSelected)="selectDates($event)"
        (timeChanged)="followUp(true)"
        (followUpTimeChange)="setFollowUpTime($event)">
      </app-lead-follow-up-popover>

      <ng-container *ngIf="!mobToggle">
        <button class="_addNew mr-2" helpTarget="lead-detail-duplicate-lead" (click)="approval.toggle($event)" *ngxPermissionsOnly="['lead.add']">
          <i class="pi pi-plus f-14"></i>
        </button>
        <div class="mt-1">
          <p-overlayPanel #approval [style]="{ width: '280px' }" [dismissable]="true" [showCloseIcon]="true" appendTo="body">
            <div class="row" *ngIf="lead_detail">
              <div class="d-flex align-items-center mb-2">
                <p>Create New Lead for</p>
                <p class="contact-name" (click)="openContactPopup(false, lead_detail)">
                  &nbsp;{{
                    lead_detail?.contact_detail?.length > 0
                      ? lead_detail?.contact_detail?.[0]?.full_name
                      : (lead_detail?.first_name || '') + ' ' + (lead_detail?.last_name || '')
                  }}
                </p>
              </div>

              <div class="col-sm-12">
                <div class="form-group mb-2">
                  <ng-select
                    [items]="leadTypes"
                    bindLabel="tag_name"
                    bindValue="tag_name"
                    [searchable]="true"
                    placeholder="Select Type"
                    [clearable]="true"
                    id="type"
                    name="type"
                    [(ngModel)]="dup_lead_type">
                    <ng-template ng-option-tmp let-item="item">
                      <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="text-right mt-2">
              <button class="_outline-btn" (click)="duplicateRecords(); approval.hide()">Save</button>
            </div>
          </p-overlayPanel>
        </div>
      </ng-container>

      <div class="contact_attempt" helpTarget="lead-detail-contact-attempt-edit" (click)="isComission = true" (clickOutside)="onClickOutSide($event)">
        <div pTooltip="Contact Attempted" tooltipPosition="bottom" class="tooltip"></div>
        <i class="pi pi-phone f-12 _fw-400"></i>
        <ul *ngIf="isComission">
          <li *ngFor="let opt of contactAttemptOptions" (click)="toggleCommissionType(opt.id)" [class.active]="commissionType?.includes(opt.id)">
            <div class="check_box" [class.active]="commissionType?.includes(opt.id)"></div>
            {{ opt.label }}
          </li>
        </ul>
        <div class="addition-note" *ngIf="commissionType?.includes('Called - Call Answered')">
          <div class="d-flex justify-content-between mb-2">
            <p class="_fw-600">Notes</p>
            <i class="pi pi-times _fw-600 primary-color f-12" (click)="hideNote()"></i>
            <!-- <p class="_fw-600 primary-color" (click)="hideNote()">Save & Close</p> -->
          </div>
          <textarea
            pInputTextarea
            spellcheck="true"
            autoresize="autoResize"
            [(ngModel)]="additional_notes"
            (ngModelChange)="onContactNoteChange()"
            style="min-height: 200px; border-radius: 8px !important; text-align: justify">
          </textarea>
        </div>
      </div>
      <ng-container *ngxPermissionsOnly="['lead.edit']">
        <button
          type="button"
          class="mr-2 _outline-btn"
          helpTarget="lead-detail-save"
          (click)="onSaveLeadDetail(false, true)"
          *ngIf="lmService.tab_levels?.length > 1">
          Save
        </button>
        <button
          type="button"
          class="_primary-btn cstBtn"
          helpTarget="lead-detail-save-close"
          (click)="onSaveLeadDetail(true)"
          *ngIf="lmService.tab_levels?.length === 1">
          Save & Close
        </button>
      </ng-container>
    </div>
  </ng-template>

  <div class="auto-save-pill-overlay" *ngIf="autoSaveEnabled && (autoSaveState === 'saving' || autoSaveState === 'error')">
    <div class="auto-save-pill" [class.is-error]="autoSaveState === 'error'" [pTooltip]="autoSaveError" tooltipPosition="bottom" aria-live="polite">
      <span class="auto-save-pill__spinner" *ngIf="autoSaveState === 'saving'"></span>
      <i class="pi pi-exclamation-triangle f-12" *ngIf="autoSaveState === 'error'"></i>
      <span>{{ autoSaveState === 'error' ? 'Auto save failed' : 'Auto save On' }}</span>
    </div>
  </div>
</div>

<!-- External EOI: generate the buyer link from the lead, and keep the issued
     link on the lead so it can be copied, reopened or reissued later. -->
<app-external-eoi-generate-modal
  [visible]="showExternalEoiModal"
  [projectId]="externalEoiProjectId"
  [projectName]="externalEoiProjectName"
  [contactId]="externalEoiContactId"
  [contactName]="getContactName()"
  [contactEmail]="externalEoiContactEmail"
  [contactMobile]="externalEoiContactMobile"
  [leadId]="lead_detail?._id || null"
  (generated)="leadEoiLinks.reload()"
  (closed)="closeExternalEoiModal()"></app-external-eoi-generate-modal>

<app-external-eoi-links
  #leadEoiLinks
  class="mt-3"
  [ngClass]="tabIndexValue === 5 ? 'd-none' : 'd-block'"
  [projectId]="externalEoiProjectId"
  [leadId]="lead_detail?._id || null"
  [agentName]="lead_detail?.agent_responsible_formatted"
  [canManage]="isAllowEdit()"></app-external-eoi-links>

<div class="mt-3">
  <div class="tab-content" id="pills-tabContent">
    <div
      class="tab-pane fade {{ tabIndexValue === 0 ? 'show active' : '' }}"
      [id]="'leadOver' + leadTabIndex"
      role="tabpanel"
      [attr.aria-labelledby]="'pills-leadOver-tab' + leadTabIndex + '-tab'"
      tabindex="0">
      <!-- REM-3537: Remmi's "may no longer be worth pursuing" banner; renders nothing unless suggested. -->
      <app-close-suggestion-banner
        [leadId]="lead_detail?._id"
        [leadName]="lead_detail?.full_name"
        [refreshKey]="closeSuggestionRefreshKey"
        (leadClosed)="onLeadClosedFromSuggestion()"></app-close-suggestion-banner>
      <div class="row position-relative">
        <div class="col-sm-9 lead-main-col pr-0">
          <div class="row">
            <div class="row equal-height-row mx-0 w-100 contact-followup-row">
              <div class="col-sm-9 px-0">
                <div class="contact-box mb-3 position-relative" helpTarget="lead-detail-contact-card">
                  <div style="position: absolute; right: 15px; bottom: 15px">
                    <p class="link-contact" (click)="show()" *ngIf="related_lead?.length > 0">Enquiry History: {{ related_lead?.length }}</p>
                    <p class="link-contact text-danger mt-2" (click)="other_lead_visible = true" *ngIf="other_leads?.length > 0">
                      Other Project Leads: {{ other_leads?.length }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2 position-relative" *ngIf="lead_detail">
                    <ng-container *ngIf="!isLeadEdit; else leadEdit">
                      <span class="user_thumb">
                        {{ lead_detail?.first_name?.charAt(0) + '' + lead_detail?.last_name?.charAt(0) }}
                      </span>
                      <p class="link-contact d-flex flex-column gap-1">
                        <a href="javascript:void(0)" class="contact_name f-18" (click)="openContactPopup(false, lead_detail)">
                          {{ lead_detail?.full_name }}
                        </a>
                        <span class="d-flex align-items-baseline gap-1">
                          <div class="temp-box" [ngStyle]="{ 'background-color': applyColorCode(editLeadForm.controls['temperature'].value) }"></div>
                          <span class="f-12">{{ editLeadForm.controls['temperature'].value }}</span>
                        </span>
                      </p>
                      <span class="time-waster-badge" *ngIf="lead_detail?.is_time_waster">
                        <i class="pi pi-exclamation-triangle mr-1"></i>Time Waster
                      </span>
                      <span class="time-waster-badge" *ngIf="!lead_detail?.is_time_waster && lead_detail?.potential_spam">
                        <i class="pi pi-flag mr-1"></i>Potential Spam
                      </span>
                      <ng-container *ngIf="editLeadForm.controls['lead_type'].value == 'Agent'">
                        <p class="link-contact d-flex flex-column gap-1 {{ !isLeadEdit && 'ml-4' }}">
                          <a
                            href="javascript:void(0)"
                            class="contact_name {{ isLeadEdit ? 'f-14' : 'f-18' }}"
                            (click)="openContactPopup(true, lead_detail)">
                            {{ isLeadEdit == true ? 'Agency' : lead_detail?.agency_name }}
                          </a>
                          <span class="d-flex align-items-baseline gap-1" *ngIf="!isLeadEdit">
                            {{ '\u00A0' }}
                          </span>
                        </p>
                      </ng-container>
                      <!-- <ng-container *ngIf="lead_detail?.alternate_fullname">
                        <p class="link-contact d-flex flex-column gap-1 {{ !isLeadEdit && 'ml-4' }}">
                          <a
                            href="javascript:void(0)"
                            class="contact_name {{ isLeadEdit ? 'f-14' : 'f-18' }}"
                            (click)="openContactPopup(false, lead_detail)">
                            {{ isLeadEdit == true ? 'Alternate Contact' : lead_detail?.alternate_fullname }}
                          </a>
                          <span class="d-flex align-items-baseline gap-1" *ngIf="!isLeadEdit">
                            {{ '\u00A0' }}
                          </span>
                        </p>
                      </ng-container> -->
                    </ng-container>
                    <ng-template #leadEdit>
                      <div class="d-flex align-items-center gap-4 position-relative w-100">
                        <div [ngClass]="{ 'ml-2': addDefaultFields?.listing }" style="width: 230px" *ngIf="isLeadEdit">
                          <re-multiselect
                            [module]="'contacts'"
                            [type]="'Contact'"
                            [contact_type]="editLeadForm.controls['lead_type'].value == 'Agent' ? 'Agent' : ''"
                            [placeholder]="'Select'"
                            [truncate]="25"
                            [isMultiple]="false"
                            [isClear]="true"
                            [selected_ids]="editLeadForm.controls['contactid'].value"
                            [agency_id]="editLeadForm.controls['agencyid'].value"
                            (editRecord)="openContactPopup(false, $event)"
                            (onUpdate)="onUpdateMSelect('contact', $event)"
                            [isFullObject]="true"
                            [style]="{ width: '100%' }"
                            [isEmail]="true">
                          </re-multiselect>
                        </div>
                        <ng-container *ngIf="editLeadForm.controls['lead_type'].value == 'Agent'; else noAgency">
                          <p class="_fw-600 f-14">Agency</p>
                          <div [ngClass]="{ 'ml-2': addDefaultFields?.listing }" style="width: 250px">
                            <re-multiselect
                              [module]="'contacts'"
                              [type]="'Company'"
                              [company_type]="'Agency'"
                              [placeholder]="'Select'"
                              [agent_id]="editLeadForm.controls['contactid'].value"
                              [truncate]="25"
                              [isMultiple]="false"
                              [isClear]="true"
                              [selected_ids]="editLeadForm.controls['agencyid'].value"
                              (editRecord)="openContactPopup(true, $event)"
                              (onUpdate)="onUpdateMSelect('company', $event)"
                              [isFullObject]="true"
                              [style]="{ width: '100%' }"
                              [isEmail]="true">
                            </re-multiselect>
                          </div>
                        </ng-container>
                        <ng-template #noAgency>
                          <!-- <p class="_fw-600 f-14">Alternate Contact</p>
                          <div [ngClass]="{ 'ml-2': addDefaultFields?.listing }" style="width: 250px">
                            <re-multiselect
                              [module]="'contacts'"
                              [type]="'Contact'"
                              [placeholder]="'Select'"
                              [truncate]="25"
                              [isMultiple]="false"
                              [isClear]="true"
                              [selected_ids]="editLeadForm.controls['alternate_contact_Id'].value"
                              (editRecord)="openContactPopup(false, $event)"
                              (onUpdate)="onUpdateMSelect('contact', $event)"
                              [isFullObject]="true"
                              [style]="{ width: '100%' }"
                              [isEmail]="true">
                            </re-multiselect>
                          </div> -->
                        </ng-template>
                        <span class="time-waster-badge" *ngIf="lead_detail?.is_time_waster">
                          <i class="pi pi-exclamation-triangle mr-1"></i>Time Waster
                        </span>
                        <span class="time-waster-badge" *ngIf="!lead_detail?.is_time_waster && lead_detail?.potential_spam">
                          <i class="pi pi-flag mr-1"></i>Potential Spam
                        </span>
                      </div>
                    </ng-template>
                  </div>

                  <div
                    class="d-flex align-items-center gap-3 mt-2"
                    [formGroup]="editLeadForm"
                    *ngIf="isLeadEdit && editLeadForm.controls['lead_type'].value == 'Agent'">
                    <div class="d-flex align-items-center gap-2">
                      <p-checkbox
                        [binary]="true"
                        inputId="edit_add_buyer_details"
                        formControlName="buyer_detail_exist"
                        (onChange)="onBuyerToggle($event)"></p-checkbox>
                      <label class="m-0" for="edit_add_buyer_details">Add Buyer Details</label>
                    </div>
                    <div style="width: 250px" *ngIf="editLeadForm.controls['buyer_detail_exist'].value">
                      <re-multiselect
                        [module]="'contacts'"
                        [type]="'Contact'"
                        [placeholder]="'Search Buyer'"
                        [truncate]="25"
                        [isMultiple]="false"
                        [isClear]="true"
                        [selected_ids]="editLeadForm.controls['buyer_contactid'].value"
                        (editRecord)="openContactPopup(false, $event)"
                        (onUpdate)="onBuyerSelect($event)"
                        [isFullObject]="true"
                        [style]="{ width: '100%' }"
                        [isEmail]="true">
                      </re-multiselect>
                    </div>
                  </div>

                  <div class="_contact-box">
                    <div class="contact_item" *ngIf="lead_detail?.email">
                      <i class="pi pi-envelope f-14"></i>
                      <a class="link-contact f-14" href="mailto:{{ lead_detail?.email }}" class="text-dark">
                        {{ lead_detail?.email }}
                      </a>
                    </div>
                    <div class="contact_item_mobile" *ngIf="lead_detail?.mobile_phone || lead_detail?.mobile_no">
                      <i class="pi pi-phone f-14"></i>
                      <a class="link-contact f-14" (click)="dialCall(lead_detail)">
                        {{ lead_detail?.mobile_phone ? (lead_detail?.mobile_phone | mobileFormat) : (lead_detail?.mobile_no | mobileFormat) }}
                      </a>
                    </div>
                    <div class="contact_item_mobile" *ngIf="lead_detail?.position">
                      <i class="pi pi-briefcase f-14"></i>
                      <a class="link-contact f-14">
                        {{ lead_detail?.position }}
                      </a>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap align-items-center gap-3 mt-2" *ngIf="lead_detail?.contact_address || showHeaderPostcode">
                    <div class="contact_address_item" *ngIf="lead_detail?.contact_address">
                      <img [src]="common_images?.location_pin" class="cursor-pointer" width="16" />
                      <p class="f-14 _fw-400">{{ lead_detail?.contact_address }}</p>
                    </div>
                    <div class="contact_address_item" *ngIf="showHeaderPostcode" pTooltip="Postcode" tooltipPosition="top">
                      <i class="pi pi-map f-14"></i>
                      <p class="f-14 _fw-400">{{ lead_detail?.postcode }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 pr-0">
                <div class="contact-box mb-3 position-relative" helpTarget="lead-detail-follow-up-tasks">
                  <div class="position-relative">
                    <p class="f-14 _fw-600 mb-4">FOLLOW UP</p>
                    <ng-container *ngFor="let task of taskList">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center gap-2">
                          <div class="circle" (click)="closeFollowUp(task)" pTooltip="Complete" tooltipPosition="top"></div>
                          <p class="cursor-pointer" (click)="addNewTask(task, false)">{{ task?.due_date | date: 'dd/MM/yy' }}</p>
                        </div>
                        <p class="cursor-pointer" (click)="addNewTask(task, false)">{{ task?.task_time }}</p>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <form [formGroup]="editLeadForm" class="form" helpTarget="lead-detail-main-form">
              <div class="row w-101 equal-height-row align-items-start">
                <div class="col-sm-9 pr-0">
                  <app-collapse-box
                    [heading]="'Lead Summary'"
                    [isFromLead]="true"
                    [AddNew]="false"
                    [isCollapsed]="false"
                    [editOnHeaderClick]="!isLeadEdit"
                    (TriggerAction)="onSectionHeaderClick($event)"
                    helpTarget="lead-detail-lead-summary">
                    <ng-container *ngIf="isLeadEdit; else notLeadEdit">
                      <div class="row">
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="lead_category">Related Lead</label>
                            <ng-select
                              [items]="leadCategory"
                              bindLabel="name"
                              bindValue="value"
                              [searchable]="true"
                              placeholder="Select Lead Category"
                              [clearable]="true"
                              id="lead_category"
                              name="lead_category"
                              formControlName="lead_category"
                              [ngClass]="{ '_input-error': isFieldInvalid('lead_category') && !editLeadForm.controls['lead_category'].value }"
                              (change)="onChangeLeadTypeRequirement()">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <ng-container *ngIf="editLeadForm.controls['lead_category'].value === 'project'">
                          <div class="col-sm-4 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                            <div class="form-group">
                              <label class="mb-1" for="lastname">Lead Enquiry</label>
                              <ng-select
                                [items]="projectList"
                                bindLabel="Project_Name"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Project"
                                [clearable]="true"
                                id="status"
                                name="status"
                                formControlName="project"
                                [ngClass]="{ '_input-error': isFieldInvalid('project') && !editLeadForm.controls['project'].value }"
                                (change)="getEOIList()">
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item.Project_Name">{{ item.Project_Name }}</div>
                                </ng-template>
                              </ng-select>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="editLeadForm.controls['lead_category'].value === 'listing'">
                          <div class="col-sm-4 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                            <div class="form-group" *ngIf="all_listing?.length > 0">
                              <label class="mb-1" for="lastname">Lead Enquiry</label>
                              <ng-select
                                [items]="all_listing"
                                bindLabel="property_address"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Listing"
                                [clearable]="true"
                                id="Listing"
                                name="Listing"
                                formControlName="listing"
                                (change)="getListingValue($event)"
                                [ngClass]="{ '_input-error': isFieldInvalid('listing') && !editLeadForm.controls['listing'].value }">
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item.property_address">{{ item.property_address }}</div>
                                </ng-template>
                              </ng-select>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="editLeadForm.controls['lead_category'].value === 'property'">
                          <div class="col-sm-4 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                            <div class="form-group">
                              <label class="mb-1" for="lastname">Lead Enquiry</label>
                              <ng-select
                                [items]="all_property"
                                bindLabel="property_address"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Property"
                                [clearable]="true"
                                id="property"
                                name="property"
                                formControlName="property"
                                (change)="getListingValue($event)"
                                [ngClass]="{ '_input-error': isFieldInvalid('property') && !editLeadForm.controls['property'].value }">
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item.property_address">{{ item.property_address }}</div>
                                </ng-template>
                              </ng-select>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="staffList?.length > 0">
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                            <div class="form-group">
                              <label class="mb-1" for="lastname">Agent Responsible</label>
                              <!-- <ng-select
                                #agentSelect
                                [items]="isAgentResponsibleTeam ? teamList : staffList"
                                bindLabel="full_name"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Agent"
                                [clearable]="true"
                                id="status"
                                name="status"
                                [ngClass]="{
                                  '_input-error': isFieldInvalid('agent_responsible') && !editLeadForm.controls['agent_responsible'].value,
                                }"
                                formControlName="agent_responsible">
                                <ng-template ng-header-tmp>
                                  <div class="active-inactive-status d-flex justify-content-between align-items-center mb-1">
                                    <p class="m-0">{{ isAgentResponsibleTeam == true ? 'Teams' : 'Users' }}</p>
                                    <div class="SP-switch">
                                      <p-inputSwitch
                                        [(ngModel)]="isAgentResponsibleTeam"
                                        [ngModelOptions]="{ standalone: true }"
                                        (onChange)="refocusSelectSearch(agentSelect)">
                                      </p-inputSwitch>
                                    </div>
                                  </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name">
                                    {{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}
                                  </div>
                                </ng-template>
                              </ng-select> -->
                              <ng-select
                                [items]="staffList"
                                bindLabel="full_name"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Agent"
                                [clearable]="true"
                                id="status"
                                name="status"
                                [ngClass]="{
                                  '_input-error': isFieldInvalid('agent_responsible') && !editLeadForm.controls['agent_responsible'].value,
                                }"
                                formControlName="agent_responsible">
                                <!-- Saved agent not in staffList (e.g. inactive/other office) — ng-select has no label
                                     for it and rendered blank, so show the lead's own formatted name instead. -->
                                <ng-template ng-label-tmp let-item="item">
                                  {{ item?.full_name || lead_detail?.agent_responsible_formatted }}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name">
                                    {{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}
                                  </div>
                                </ng-template>
                              </ng-select>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                            <div class="form-group">
                              <label class="mb-1" for="firstname">Owner</label>
                              <ng-select
                                #ownerSelect
                                [items]="isOwnerTeam ? teamList : staffList"
                                bindLabel="full_name"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Owner"
                                [clearable]="true"
                                id="status"
                                name="status"
                                [ngClass]="{ '_input-error': isFieldInvalid('Owner') && !editLeadForm.controls['Owner'].value }"
                                formControlName="Owner">
                                <ng-template ng-header-tmp>
                                  <div class="active-inactive-status d-flex justify-content-between align-items-center mb-1">
                                    <p class="m-0">{{ isOwnerTeam == true ? 'Teams' : 'Users' }}</p>
                                    <div class="SP-switch">
                                      <p-inputSwitch
                                        [(ngModel)]="isOwnerTeam"
                                        [ngModelOptions]="{ standalone: true }"
                                        (onChange)="refocusSelectSearch(ownerSelect)">
                                      </p-inputSwitch>
                                    </div>
                                  </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name">
                                    {{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}
                                  </div>
                                </ng-template>
                              </ng-select>
                            </div>
                          </div>
                        </ng-container>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Lead Type</label>
                            <ng-select
                              [items]="leadTypes"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Type"
                              [clearable]="true"
                              id="type"
                              name="type"
                              [ngClass]="{ '_input-error': isFieldInvalid('lead_type') && !editLeadForm.controls['lead_type'].value }"
                              formControlName="lead_type"
                              (change)="allocateTagsToFields('lead-status')">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-4 {{ mobToggle ? 'px-0' : 'pl-0' }}">
                          <div class="flex_center_wrap">
                            <label class="mb-1" for="firstname">
                              Lead Status
                              <ng-select
                                [items]="leadStatus"
                                bindLabel="tag_name"
                                bindValue="tag_name"
                                [searchable]="true"
                                placeholder="Select Status"
                                [clearable]="true"
                                id="status"
                                name="status"
                                formControlName="lead_status"
                                class="{{ mobToggle ? 'w-100' : 'w-75' }}"
                                [ngClass]="{ '_input-error': isFieldInvalid('lead_status') && !editLeadForm.controls['lead_status'].value }"
                                (change)="changeLeadStatus($event)">
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                                </ng-template>
                              </ng-select>
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-3 pl-0" *ngIf="editLeadForm.controls['lead_type'].value?.includes('Agent')">
                          <div class="form-group">
                            <label class="mb-1" for="lastname">Agreement Status</label>
                            <ng-select
                              [items]="agreementList"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Agreement Status"
                              [clearable]="true"
                              id="agreement"
                              name="agreement"
                              [ngClass]="{ '_input-error': isFieldInvalid('agreement') && !editLeadForm.controls['agreement'].value }"
                              formControlName="agreement">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div
                          class="col-sm-3 {{ mobToggle ? 'px-0' : ' pl-0' }}"
                          *ngIf="editLeadForm.controls['lead_status'].value == 'No Further Interest'">
                          <div class="flex_center_wrap">
                            <label class="mb-1" for="firstname">
                              No Further Interest
                              <ng-select
                                [items]="not_interested_reason"
                                bindLabel="tag_name"
                                bindValue="tag_name"
                                [searchable]="true"
                                placeholder="Select Status"
                                [clearable]="true"
                                id="status"
                                name="status"
                                [ngClass]="{ '_input-error': isFieldInvalid('not_interested') && !editLeadForm.controls['not_interested'].value }"
                                formControlName="not_interested"
                                class="{{ mobToggle ? 'w-100' : 'w-75' }}">
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                                </ng-template>
                              </ng-select>
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Lead Source</label>
                            <ng-select
                              [items]="leadSource"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Source"
                              [clearable]="true"
                              id="source"
                              name="source"
                              [ngClass]="{ '_input-error': isFieldInvalid('lead_source') && !editLeadForm.controls['lead_source'].value }"
                              formControlName="lead_source">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div
                          class="col-sm-3 {{ mobToggle ? 'px-1' : 'pl-0' }}"
                          *ngIf="editLeadForm.controls['lead_status'].value !== 'No Further Interest'">
                          <div class="form-group">
                            <label for="firstname" class="mb-1">Enquiry Type</label>
                            <ng-select
                              [items]="enquiry_Type"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Type"
                              [clearable]="true"
                              id="enquiry_type"
                              name="enquiry_type"
                              [ngClass]="{ '_input-error': isFieldInvalid('enquiry_type') && !editLeadForm.controls['enquiry_type'].value }"
                              formControlName="enquiry_type">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <div class="form-group">
                            <label for="firstname" class="mb-1">Lead Interest</label>
                            <ng-select
                              [items]="temperature"
                              [searchable]="true"
                              placeholder="Select Status"
                              [clearable]="true"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              id="tag_name"
                              name="tag_name"
                              [ngClass]="{ '_input-error': isFieldInvalid('temperature') && !editLeadForm.controls['temperature'].value }"
                              formControlName="temperature">
                            </ng-select>
                          </div>
                        </div>
                        <!-- <div class="col-sm-3 {{ mobToggle ? 'px-1' : 'pl-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="sub_office_id">Sub Office</label>
                            <ng-select
                              [items]="subOfficeList"
                              bindLabel="office_name"
                              bindValue="_id"
                              [searchable]="true"
                              [clearable]="true"
                              placeholder="Select Sub Office"
                              formControlName="sub_office_id"></ng-select>
                          </div>
                        </div> -->
                        <div class="col-sm-4 pl-0" *ngIf="editLeadForm.controls['lead_status'].value == 'No Further Interest'">
                          <div class="form-group">
                            <label for="firstname" class="mb-1">Enquiry Type</label>
                            <ng-select
                              [items]="enquiry_Type"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Type"
                              [clearable]="true"
                              id="enquiry_type"
                              name="enquiry_type"
                              [ngClass]="{ '_input-error': isFieldInvalid('enquiry_type') && !editLeadForm.controls['enquiry_type'].value }"
                              formControlName="enquiry_type">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div
                          class="col-sm-2 d-flex align-items-center mt-3
                        {{ editLeadForm.controls['lead_status'].value == 'No Further Interest' && 'pl-0' }}"
                          *ngIf="editLeadForm.controls['lead_category'].value !== 'project'">
                          <p-checkbox formControlName="application_submitted" binary="true"></p-checkbox>
                          <label class="mb-1 ml-2" for="firstname">Application Submitted</label>
                        </div>
                        <ng-container
                          *ngIf="
                            editLeadForm.controls['lead_category'].value == 'project' && editLeadForm.controls['lead_status'].value == 'Purchased'
                          ">
                          <div class="col-md-7 pl-0 {{ mobToggle ? 'px-0' : '' }}">
                            <div class="flex_center_wrap">
                              <label class="mb-1" for="firstname">
                                EOI
                                <ng-select
                                  [items]="eoi_list"
                                  bindLabel="display_name"
                                  bindValue="_id"
                                  [searchable]="true"
                                  placeholder="Select EOI"
                                  [clearable]="true"
                                  id="status"
                                  name="status"
                                  [ngClass]="{ '_input-error': isFieldInvalid('lead_eoi') && !editLeadForm.controls['lead_eoi'].value }"
                                  formControlName="lead_eoi"
                                  class="{{ mobToggle ? 'w-100' : 'w-75' }}">
                                  <ng-template ng-header-tmp>
                                    <p class="cursor-pointer d-flex align-items-center" (click)="createEOI()">
                                      <i class="pi pi-plus f-12 mr-1"></i> Create new
                                    </p>
                                  </ng-template>
                                  <ng-template ng-option-tmp let-item="item">
                                    <div class="eoi-option" tooltipPosition="top" [pTooltip]="item.display_name">
                                      <p class="lot">Lot: {{ item.lot_name }}</p>
                                      <div class="eoi-right-boarder"></div>
                                      <p class="status">Status: {{ item.status_reason }}</p>
                                      <div class="eoi-right-boarder"></div>
                                      <p class="purchaser">Purchaser: {{ item.client_name || 'No contact added' }}</p>
                                    </div>
                                  </ng-template>
                                </ng-select>
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-5 pl-0" style="margin-top: 35px" *ngIf="lead_detail?.eoi_cancelled">
                            <div class="flex_center_wrap gap-3">
                              <p class="text-danger">Cancelled Date: {{ createdDate(lead_detail?.eoi_cancelled_date) }}</p>
                              <p class="text-danger">Reason: {{ lead_detail?.eoi_cancelled_reason }}</p>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-template #notLeadEdit>
                      <div class="field_box cursor-pointer" (click)="enableEditMode()">
                        <div class="field_">
                          <p class="title_">Related Lead</p>
                          <p class="text-capitalize">{{ editLeadForm.controls['lead_category'].value }}</p>
                        </div>
                        <div class="field_">
                          <p class="title_">Lead Enquiry</p>
                          <p>
                            {{
                              editLeadForm.controls['lead_category'].value == 'project'
                                ? lead_detail?.listing_project?.project
                                : editLeadForm.controls['lead_category'].value == 'listing'
                                  ? lead_detail?.listing_project?.listing
                                  : editLeadForm.controls['lead_category'].value == 'property'
                                    ? lead_detail?.listing_project?.property
                                    : ''
                            }}
                          </p>
                        </div>
                        <div class="field_">
                          <p class="title_">Agent Responsible</p>
                          <p>{{ lead_detail?.agent_responsible_formatted }}</p>
                        </div>
                        <div class="field_">
                          <p class="title_">Owner</p>
                          <p>{{ lead_detail?.Owner_formatted }}</p>
                        </div>
                        <div class="field_">
                          <p class="title_">Lead Type</p>
                          <p>{{ editLeadForm.controls['lead_type'].value }}</p>
                        </div>
                        <div class="field_">
                          <p class="title_">Lead Status</p>
                          <p>{{ editLeadForm.controls['lead_status'].value }}</p>
                        </div>
                        <div class="field_" *ngIf="editLeadForm.controls['lead_type'].value?.includes('Agent')">
                          <p class="title_">Agreement Status</p>
                          <p>{{ editLeadForm.controls['agreement'].value }}</p>
                        </div>
                        <div class="field_">
                          <p class="title_">Lead Source</p>
                          <p>{{ editLeadForm.controls['lead_source'].value }}</p>
                        </div>
                        <div class="field_">
                          <p class="title_">Enquiry Type</p>
                          <p>{{ editLeadForm.controls['enquiry_type'].value }}</p>
                        </div>
                        <!-- <div class="field_">
                          <p class="title_">Sub Office</p>
                          <p>{{ lead_detail?.sub_office_name }}</p>
                        </div> -->
                        <div class="field_" *ngIf="editLeadForm.controls['lead_status'].value == 'No Further Interest'">
                          <p class="title_">No Further Interest</p>
                          <p>{{ editLeadForm.controls['not_interested'].value }}</p>
                        </div>
                        <div class="field_" *ngIf="editLeadForm.controls['lead_category'].value !== 'project'">
                          <p class="title_">Application Submitted</p>
                          <p>{{ editLeadForm.controls['application_submitted'].value === false ? 'No' : 'Yes' }}</p>
                        </div>
                        <div class="field_" style="width: calc(50% - 5px)" *ngIf="editLeadForm.controls['lead_status'].value === 'Purchased'">
                          <p class="title_">EOI</p>
                          <p>{{ lead_detail?.eoi_detail }}</p>
                          <div></div>
                        </div>
                      </div>
                    </ng-template>
                  </app-collapse-box>
                </div>
                <div class="col-sm-3 pr-0">
                  <app-collapse-box
                    [heading]="isInspectionEmpty() ? 'Inspection' : 'Inspection'"
                    [isFromLead]="true"
                    [AddNew]="false"
                    [isCollapsed]="isInspectionEmpty() ? true : false"
                    [editOnHeaderClick]="!isLeadEdit"
                    (TriggerAction)="onSectionHeaderClick($event)"
                    helpTarget="lead-detail-inspection">
                    <ng-container *ngIf="isLeadEdit; else notLeadEdit3">
                      <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
                        <div style="width: 100px">
                          <p class="mb-1">Inspection Date</p>
                          <p-calendar
                            formControlName="inspection_dateTime"
                            dateFormat="dd/mm/yy"
                            placeholder="dd/mm/yy"
                            [ngClass]="{
                              invalidCalendarField: isFieldInvalid('inspection_dateTime') && !editLeadForm.controls['inspection_dateTime'].value,
                            }"
                            (onSelect)="selectDate()">
                          </p-calendar>
                        </div>
                        <div style="width: 100px">
                          <p class="mb-1">Time</p>
                          <ng-select
                            [items]="inspection_timer_options"
                            [searchable]="true"
                            [ngClass]="{ '_input-error': isFieldInvalid('inspection_time') && !editLeadForm.controls['inspection_time'].value }"
                            [clearable]="false"
                            id="type"
                            name="type"
                            [(ngModel)]="inspectionTime"
                            (ngModelChange)="scheduleAutoSave()"
                            [ngModelOptions]="{ standalone: true }">
                          </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <p class="mb-3 _fw-600">Inspection Status</p>
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                          <div class="d-flex align-items-center gap-2">
                            <p>Booked</p>
                            <p-checkbox formControlName="inspection_booked" (onChange)="onChangeBooked($event)" binary="true"></p-checkbox>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <p>Completed</p>
                            <p-checkbox formControlName="inspection_complete" (onChange)="onChangeCompleted($event)" binary="true"></p-checkbox>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <p>Cancelled</p>
                            <p-checkbox formControlName="inspection_cancelled" (onChange)="onChangeCancelled($event)" binary="true"></p-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end mt-2" *ngIf="project_appointment_list?.length > 0">
                        <p class="count-box m-0" (click)="openInspection()" tooltipPosition="top" pTooltip="Appointments">
                          {{ project_appointment_list?.length }}
                        </p>
                      </div>
                    </ng-container>
                    <ng-template #notLeadEdit3>
                      <div class="cursor-pointer" (click)="enableEditMode()">
                        <div class="d-flex align-items-center gap-3 flex-wrap">
                          <div class="d-flex align-items-center gap-5 w-100">
                            <p>{{ editLeadForm.controls['inspection_dateTime'].value | date: 'dd/MM/yy' }}</p>
                            <p>{{ inspectionTime }}</p>
                          </div>
                        </div>
                        <ng-container
                          *ngIf="
                            editLeadForm.controls['inspection_booked'].value ||
                            editLeadForm.controls['inspection_complete'].value ||
                            editLeadForm.controls['inspection_cancelled'].value
                          ">
                          <p class="my-3 _fw-600">Inspection Status</p>
                          <div class="d-flex align-items-center gap-3 flex-wrap mt-3">
                            <div class="d-flex align-items-center gap-3" *ngIf="editLeadForm.controls['inspection_booked'].value">
                              <p class="searchIcon-color">Booked</p>
                              <p>{{ editLeadForm.controls['inspection_booked'].value == true ? 'Yes' : 'No' }}</p>
                            </div>
                            <div class="d-flex align-items-center gap-3" *ngIf="editLeadForm.controls['inspection_complete'].value">
                              <p class="searchIcon-color">Completed</p>
                              <p>{{ editLeadForm.controls['inspection_complete'].value == true ? 'Yes' : 'No' }}</p>
                            </div>
                            <div class="d-flex align-items-center gap-3" *ngIf="editLeadForm.controls['inspection_cancelled'].value">
                              <p class="searchIcon-color">Cancelled</p>
                              <p>{{ editLeadForm.controls['inspection_cancelled'].value == true ? 'Yes' : 'No' }}</p>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="d-flex justify-content-end mt-2" *ngIf="project_appointment_list?.length > 0">
                        <p class="count-box m-0" (click)="openInspection()" tooltipPosition="top" pTooltip="Appointments">
                          {{ project_appointment_list?.length }}
                        </p>
                      </div>
                    </ng-template>
                  </app-collapse-box>
                </div>
              </div>
              <div class="row w-101 equal-height-row align-items-start">
                <div class="col-sm-9 pr-0">
                  <app-collapse-box
                    [heading]="
                      isSectionIncomplete('report_notes', editLeadForm.controls['report_notes'].value == '')
                        ? 'Report Notes (To Be Completed)'
                        : 'Report Notes'
                    "
                    [isFromLead]="true"
                    [AddNew]="false"
                    [isCollapsed]="isSectionIncomplete('report_notes', editLeadForm.controls['report_notes'].value == '')"
                    [editOnHeaderClick]="!isLeadEdit"
                    (TriggerAction)="onSectionHeaderClick($event)"
                    helpTarget="lead-detail-report-notes">
                    <ng-container *ngIf="isLeadEdit; else notLeadEdit4">
                      <textarea
                        pInputTextarea
                        spellcheck="true"
                        autoresize="autoResize"
                        formControlName="report_notes"
                        style="overflow: auto; height: 100px; border-radius: 16px !important; text-align: justify">
                      </textarea>
                    </ng-container>
                    <ng-template #notLeadEdit4>
                      <pre
                        *ngIf="editLeadForm.controls['report_notes'].value; else emptyReportNotes"
                        class="paragraph-style cursor-pointer"
                        (click)="enableEditMode()"
                        >{{ editLeadForm.controls['report_notes'].value }}</pre
                      >
                      <ng-template #emptyReportNotes>
                        <p class="empty-edit-hint" (click)="enableEditMode()">Click to Add Report Notes</p>
                      </ng-template>
                    </ng-template>
                  </app-collapse-box>
                </div>
                <div class="col-sm-3 pr-0">
                  <app-lead-report-notes-summary
                    [editLeadForm]="editLeadForm"
                    [isLeadEdit]="isLeadEdit"
                    [leadId]="lead_detail?._id"
                    [canPersistSummary]="isLeadDetailLoaded"
                    (summaryPersistRequested)="persistReportNotesSummary()">
                  </app-lead-report-notes-summary>
                </div>
              </div>
              <ng-container
                *ngIf="
                  editLeadForm.controls['lead_type'].value?.includes('Agent') ||
                  editLeadForm.controls['lead_type'].value?.includes('Buyer') ||
                  editLeadForm.controls['lead_type'].value?.includes('Seller') ||
                  editLeadForm.controls['lead_type'].value?.includes('Developer')
                ">
                <app-collapse-box
                  [heading]="
                    editLeadForm.controls['lead_type'].value?.includes('Agent')
                      ? 'Lead Information'
                      : isSectionIncomplete('requirements', isRequirementsEmpty())
                        ? 'Requirements (To Be Completed)'
                        : 'Requirements'
                  "
                  [isFromLead]="true"
                  [AddNew]="false"
                  [isCollapsed]="isSectionIncomplete('requirements', isRequirementsEmpty())"
                  [editOnHeaderClick]="!isLeadEdit"
                  (TriggerAction)="onSectionHeaderClick($event)"
                  helpTarget="lead-detail-requirements">
                  <ng-container *ngIf="isLeadEdit; else notLeadEdit2">
                    <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Agent')">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="form-group mb-2">
                            <label for="lastname">Project Information Sent</label>
                            <p-calendar
                              formControlName="project_information_sent_date"
                              dateFormat="dd/mm/yy"
                              placeholder="Project Information Sent Date"
                              [ngClass]="{
                                invalidCalendarField:
                                  isFieldInvalid('project_information_sent_date') && !editLeadForm.controls['project_information_sent_date'].value,
                              }"
                              (onSelect)="selectNewDateField()"></p-calendar>
                          </div>
                        </div>
                        <div class="col-sm-3 px-0">
                          <div class="form-group mb-2">
                            <label for="lastname">Agreement Sent</label>
                            <p-calendar
                              formControlName="agreement_sent_date"
                              dateFormat="dd/mm/yy"
                              [ngClass]="{
                                invalidCalendarField: isFieldInvalid('agreement_sent_date') && !editLeadForm.controls['agreement_sent_date'].value,
                              }"
                              placeholder="Agreement Sent Date"
                              (onSelect)="selectNewDateField()"></p-calendar>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-3">
                          <p class="mb-1">Briefing</p>
                          <p-calendar
                            formControlName="personal_briefing_date"
                            dateFormat="dd/mm/yy"
                            [ngClass]="{
                              invalidCalendarField:
                                isFieldInvalid('personal_briefing_date') && !editLeadForm.controls['personal_briefing_date'].value,
                            }"
                            placeholder="dd/mm/yy"
                            (onSelect)="selectNewDateField()">
                          </p-calendar>
                        </div>
                        <div class="col-sm-3 pl-0">
                          <p class="mb-1">Time</p>
                          <ng-select
                            [items]="inspection_timer_options"
                            [searchable]="true"
                            placeholder="Time"
                            [clearable]="true"
                            [ngClass]="{
                              '_input-error': isFieldInvalid('personal_briefing_time') && !editLeadForm.controls['personal_briefing_time'].value,
                            }"
                            id="type"
                            name="type"
                            formControlName="personal_briefing_time">
                          </ng-select>
                        </div>
                        <div class="col-sm-3 pl-0">
                          <p class="mb-1">Onsite Training</p>
                          <p-calendar
                            formControlName="onsite_training_date"
                            dateFormat="dd/mm/yy"
                            [ngClass]="{
                              invalidCalendarField: isFieldInvalid('onsite_training_date') && !editLeadForm.controls['onsite_training_date'].value,
                            }"
                            placeholder="dd/mm/yy"
                            (onSelect)="selectNewDateField()">
                          </p-calendar>
                        </div>
                        <div class="col-sm-3 pl-0">
                          <p class="mb-1">Time</p>
                          <ng-select
                            [items]="inspection_timer_options"
                            [searchable]="true"
                            placeholder="Select Time"
                            [ngClass]="{
                              '_input-error': isFieldInvalid('onsite_training_time') && !editLeadForm.controls['onsite_training_time'].value,
                            }"
                            [clearable]="true"
                            id="type"
                            name="type"
                            formControlName="onsite_training_time">
                          </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 mt-2">
                          <p class="mb-1">Comments</p>
                          <textarea
                            pInputTextarea
                            spellcheck="true"
                            autoresize="autoResize"
                            formControlName="comments"
                            style="overflow: auto; height: 100px; border-radius: 16px !important; text-align: justify">
                          </textarea>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Buyer')">
                      <div class="row">
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'pr-0' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="lastname">Property Type</label>
                            <ng-select
                              [items]="listingTypes"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Property Type"
                              [clearable]="true"
                              id="Listing"
                              [ngClass]="{ '_input-error': isFieldInvalid('listing_type') && !editLeadForm.controls['listing_type'].value }"
                              name="Listing"
                              formControlName="listing_type">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : 'pr-0' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="priceRange">Price Range</label>
                            <ng-select
                              [items]="budgetList"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select"
                              [clearable]="true"
                              id="Listing"
                              name="Listing"
                              [ngClass]="{ '_input-error': isFieldInvalid('price_range') && !editLeadForm.controls['price_range'].value }"
                              formControlName="price_range">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Bedrooms</label>
                            <ng-select
                              [items]="bedrooms"
                              bindLabel="bed"
                              bindValue="bed"
                              [searchable]="true"
                              [ngClass]="{ '_input-error': isFieldInvalid('beds') && !editLeadForm.controls['beds'].value }"
                              placeholder="Select"
                              [clearable]="true"
                              id="bed"
                              name="bed"
                              formControlName="beds">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.bed">{{ item.bed }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'px-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Bathrooms</label>
                            <ng-select
                              [items]="bathrooms"
                              bindLabel="bath"
                              bindValue="bath"
                              [searchable]="true"
                              [ngClass]="{ '_input-error': isFieldInvalid('baths') && !editLeadForm.controls['baths'].value }"
                              placeholder="Bathrooms"
                              [clearable]="true"
                              id="bed"
                              name="bed"
                              formControlName="baths">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Car Parks</label>
                            <ng-select
                              [items]="bathrooms"
                              bindLabel="bath"
                              bindValue="bath"
                              [searchable]="true"
                              [ngClass]="{ '_input-error': isFieldInvalid('car') && !editLeadForm.controls['car'].value }"
                              placeholder="Car parks"
                              [clearable]="true"
                              id="car"
                              name="car"
                              formControlName="car">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : ' pr-0' }}">
                          <div class="form-group">
                            <label class="mb-1 text-nowrap" for="firstname">New or Established</label>
                            <ng-select
                              [items]="Established_property"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Established Property"
                              [clearable]="true"
                              id="established_property"
                              name="established_property"
                              [ngClass]="{
                                '_input-error': isFieldInvalid('established_property') && !editLeadForm.controls['established_property'].value,
                              }"
                              formControlName="established_property">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>

                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : ' pr-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Intended Use</label>
                            <ng-select
                              [items]="intended_use"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Intended Use"
                              [clearable]="true"
                              id="intended_use"
                              [ngClass]="{ '_input-error': isFieldInvalid('intended_use') && !editLeadForm.controls['intended_use'].value }"
                              name="intended_use"
                              formControlName="intended_use">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Land Size</label>
                            <ng-select
                              [items]="land_size"
                              bindLabel="land_size"
                              bindValue="land_size"
                              [searchable]="true"
                              placeholder="Min"
                              [clearable]="true"
                              id="land_size"
                              name="land_size"
                              [ngClass]="{ '_input-error': isFieldInvalid('min_land_area') && !editLeadForm.controls['min_land_area'].value }"
                              formControlName="min_land_area">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.land_size">{{ item.land_size }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : ' px-0' }}">
                          <div class="form-group">
                            <label class="mb-1 invisible" for="firstname">Max</label>
                            <ng-select
                              [items]="land_size"
                              bindLabel="land_size"
                              bindValue="land_size"
                              [searchable]="true"
                              placeholder="Max"
                              [clearable]="true"
                              class="mt-1"
                              id="land_size"
                              name="land_size"
                              [ngClass]="{ '_input-error': isFieldInvalid('max_land_area') && !editLeadForm.controls['max_land_area'].value }"
                              name="land_size"
                              formControlName="max_land_area">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.land_size">{{ item.land_size }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>

                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Buyer Timeframe</label>
                            <ng-select
                              [items]="time_frame"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Time Frame"
                              [clearable]="true"
                              id="time_frame"
                              [ngClass]="{ '_input-error': isFieldInvalid('time_frame') && !editLeadForm.controls['time_frame'].value }"
                              name="time_frame"
                              formControlName="time_frame">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'pr-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Age Group</label>
                            <ng-select
                              [items]="age_group"
                              bindLabel="name"
                              bindValue="value"
                              [searchable]="true"
                              placeholder="Age Group"
                              [clearable]="true"
                              id="age_group"
                              name="age_group"
                              [ngClass]="{ '_input-error': isFieldInvalid('age_group') && !editLeadForm.controls['age_group'].value }"
                              formControlName="age_group">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : ' pr-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Reason For Buying</label>
                            <ng-select
                              [items]="reason_for_buying"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Reason For Buying"
                              [clearable]="true"
                              [ngClass]="{ '_input-error': isFieldInvalid('reason_for_buying') && !editLeadForm.controls['reason_for_buying'].value }"
                              id="reason_for_buying"
                              name="reason_for_buying"
                              formControlName="reason_for_buying">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Outdoor Feature</label>
                            <re-multiSelect
                              [options]="outdoor_feature"
                              formControlName="outdoor_feature"
                              optionLabel="tag_name"
                              optionValue="tag_name"
                              placeholder="Outdoor"
                              [style]="{ width: '100%' }"
                              [required_class]="
                                isFieldInvalid('outdoor_feature') && !editLeadForm.controls['outdoor_feature'].value ? 'is-invalid' : ''
                              ">
                            </re-multiSelect>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'px-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Indoor Feature</label>
                            <re-multiSelect
                              [options]="indoor_feature"
                              formControlName="indoor_feature"
                              optionLabel="tag_name"
                              optionValue="tag_name"
                              placeholder="Indoor"
                              [style]="{ width: '100%' }"
                              [required_class]="
                                isFieldInvalid('outdoor_feature') && !editLeadForm.controls['outdoor_feature'].value ? 'is-invalid' : ''
                              ">
                            </re-multiSelect>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Seller')">
                      <div class="row">
                        <div class="col-sm-4 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="lastname">Address</label>
                            <input
                              class="site-input addressSearch"
                              placeholder="Search Address"
                              google-places-autocomplete
                              [options]="options"
                              formControlName="address"
                              [ngClass]="{ invalidField: isFieldInvalid('address') && !editLeadForm.controls['address'].value }"
                              (onAddressChange)="handleAddressChange($event, 'address')" />
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'px-0' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="lastname">Property Type</label>
                            <ng-select
                              [items]="listingTypes"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Property Type"
                              [clearable]="true"
                              id="Listing"
                              [ngClass]="{ '_input-error': isFieldInvalid('listing_type') && !editLeadForm.controls['listing_type'].value }"
                              name="Listing"
                              formControlName="listing_type">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Price Range</label>
                            <ng-select
                              [items]="budgetList"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select"
                              [clearable]="true"
                              id="Listing"
                              name="Listing"
                              [ngClass]="{ '_input-error': isFieldInvalid('price_range') && !editLeadForm.controls['price_range'].value }"
                              formControlName="price_range">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'px-0' }}">
                          <div class="form-group">
                            <label for="firstname" class="mb-1">Bedrooms</label>
                            <ng-select
                              [items]="bedrooms"
                              bindLabel="bed"
                              bindValue="bed"
                              [searchable]="true"
                              placeholder="Select"
                              [clearable]="true"
                              id="bed"
                              name="bed"
                              formControlName="beds"
                              [ngClass]="{ '_input-error': isFieldInvalid('beds') && !editLeadForm.controls['beds'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.bed">{{ item.bed }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label for="firstname" class="mb-1">Bathrooms</label>
                            <ng-select
                              [items]="bathrooms"
                              bindLabel="bath"
                              bindValue="bath"
                              [searchable]="true"
                              placeholder="Bathrooms"
                              [clearable]="true"
                              id="bed"
                              name="bed"
                              formControlName="baths"
                              [ngClass]="{ '_input-error': isFieldInvalid('baths') && !editLeadForm.controls['baths'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label for="firstname">Car Parks</label>
                            <ng-select
                              [items]="bathrooms"
                              bindLabel="bath"
                              bindValue="bath"
                              [searchable]="true"
                              placeholder="Car parks"
                              [clearable]="true"
                              id="car"
                              name="car"
                              formControlName="car"
                              [ngClass]="{ '_input-error': isFieldInvalid('car') && !editLeadForm.controls['car'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.bath">{{ item.bath }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : ' pl-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Reason For Selling</label>
                            <ng-select
                              [items]="reason_for_selling"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Reason For Selling"
                              [clearable]="true"
                              id="reason_for_selling"
                              name="reason_for_selling"
                              formControlName="reason_for_selling"
                              [ngClass]="{
                                '_input-error': isFieldInvalid('reason_for_selling') && !editLeadForm.controls['reason_for_selling'].value,
                              }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'px-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Current Purpose</label>
                            <ng-select
                              [items]="current_purpose"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Current Purpose"
                              [clearable]="true"
                              id="current_purpose"
                              name="current_purpose"
                              formControlName="current_purpose"
                              [ngClass]="{ '_input-error': isFieldInvalid('current_purpose') && !editLeadForm.controls['current_purpose'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Selling Timeframe</label>
                            <ng-select
                              [items]="time_frame"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Time Frame"
                              [clearable]="true"
                              id="time_frame"
                              name="time_frame"
                              formControlName="time_frame"
                              [ngClass]="{ '_input-error': isFieldInvalid('time_frame') && !editLeadForm.controls['time_frame'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : 'px-0' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Age Group</label>
                            <ng-select
                              [items]="age_group"
                              bindLabel="name"
                              bindValue="value"
                              [searchable]="true"
                              placeholder="Age Group"
                              [clearable]="true"
                              id="age_group"
                              name="age_group"
                              formControlName="age_group"
                              [ngClass]="{ '_input-error': isFieldInvalid('age_group') && !editLeadForm.controls['age_group'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Tenancy Details</label>
                            <ng-select
                              [items]="tenancy_details"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Tenancy Details"
                              [clearable]="true"
                              id="tenancy_details"
                              name="tenancy_details"
                              formControlName="tenancy_details"
                              [ngClass]="{ '_input-error': isFieldInvalid('tenancy_details') && !editLeadForm.controls['tenancy_details'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-2 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Tenancy End Date</label>
                            <p-calendar
                              formControlName="tenancy_end_date"
                              dateFormat="dd/mm/yy"
                              [ngClass]="{
                                invalidCalendarField: isFieldInvalid('tenancy_end_date') && !editLeadForm.controls['tenancy_end_date'].value,
                              }"
                              placeholder="Tenancy End Date"></p-calendar>
                          </div>
                        </div>
                        <div class="col-sm-4 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group">
                            <label class="mb-1" for="features">Features</label>
                            <re-multiSelect
                              [options]="lmService?.property_features"
                              formControlName="features"
                              optionLabel="feature_name"
                              optionValue="feature_name"
                              placeholder="Feature"
                              [required_class]="isFieldInvalid('feature_name') && !editLeadForm.controls['feature_name'].value ? 'is-invalid' : ''">
                            </re-multiSelect>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Developer')">
                      <div class="row">
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Development Type</label>
                            <ng-select
                              [items]="developmentType"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Type"
                              [clearable]="true"
                              id="development_type"
                              name="development_type"
                              formControlName="development_type"
                              [ngClass]="{ '_input-error': isFieldInvalid('development_type') && !editLeadForm.controls['development_type'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Project Address</label>
                            <input
                              class="mt-1 site-input addressSearch"
                              placeholder="Search Address"
                              google-places-autocomplete
                              [options]="options"
                              (onAddressChange)="handleAddressChange($event, 'project_address')"
                              formControlName="project_address"
                              [ngClass]="{ invalidField: isFieldInvalid('project_address') && !editLeadForm.controls['project_address'].value }" />
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Project Suburb</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="project_suburb"
                              [ngClass]="{ invalidField: isFieldInvalid('project_suburb') && !editLeadForm.controls['project_suburb'].value }" />
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Project Status</label>
                            <ng-select
                              [items]="projectStatus"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select Status"
                              [clearable]="true"
                              id="project_status"
                              name="project_status"
                              formControlName="project_status"
                              [ngClass]="{ '_input-error': isFieldInvalid('project_status') && !editLeadForm.controls['project_status'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Lot Quantity</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="lot_quantity"
                              [ngClass]="{ invalidField: isFieldInvalid('lot_quantity') && !editLeadForm.controls['lot_quantity'].value }" />
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Currently Marketed</label>
                            <ng-select
                              class="mt-1"
                              formControlName="current_market"
                              [items]="currently_marketed"
                              [ngClass]="{ '_input-error': isFieldInvalid('current_market') && !editLeadForm.controls['current_market'].value }"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              [multiple]="false"
                              placeholder="Select Currently Marketed">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Product Mix</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="product_mix"
                              [ngClass]="{ invalidField: isFieldInvalid('product_mix') && !editLeadForm.controls['product_mix'].value }" />
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Price Range</label>
                            <ng-select
                              [items]="budgetList"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Select"
                              [clearable]="true"
                              id="Listing"
                              name="Listing"
                              formControlName="price_range"
                              [ngClass]="{ '_input-error': isFieldInvalid('price_range') && !editLeadForm.controls['price_range'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Timeframe</label>
                            <ng-select
                              [items]="time_frame"
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [searchable]="true"
                              placeholder="Time Frame"
                              [clearable]="true"
                              id="time_frame"
                              name="time_frame"
                              formControlName="time_frame"
                              [ngClass]="{ '_input-error': isFieldInvalid('time_frame') && !editLeadForm.controls['time_frame'].value }">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Levels</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="levels"
                              [ngClass]="{ invalidField: isFieldInvalid('levels') && !editLeadForm.controls['levels'].value }" />
                          </div>
                        </div>
                        <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}">
                          <div class="form-group mb-2">
                            <label class="mb-1" for="firstname">Amenities</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="amenities"
                              [ngClass]="{ invalidField: isFieldInvalid('amenities') && !editLeadForm.controls['amenities'].value }" />
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #notLeadEdit2>
                    <p class="empty-edit-hint" *ngIf="isRequirementsEmpty()" (click)="enableEditMode()">Click to Add Requirements</p>
                    <div class="cursor-pointer" (click)="enableEditMode()">
                      <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Agent')">
                        <div class="d-flex align-items-center gap-3 flex-wrap">
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['project_information_sent_date'].value">
                            <label class="mb-1 searchIcon-color" for="lastname">Project Information Sent</label>
                            <p>{{ editLeadForm.controls['project_information_sent_date'].value | date: 'dd/MM/yy' }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['agreement_sent_date'].value">
                            <label class="mb-1 searchIcon-color" for="priceRange">Agreement Sent</label>
                            <p>{{ editLeadForm.controls['agreement_sent_date'].value | date: 'dd/MM/yy' }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['personal_briefing_date'].value">
                            <label class="mb-1 searchIcon-color" for="lastname">Personal Briefing</label>
                            <p>{{ editLeadForm.controls['personal_briefing_date'].value | date: 'dd/MM/yy' }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['personal_briefing_time'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Time</label>
                            <p>{{ editLeadForm.controls['personal_briefing_time'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['onsite_training_date'].value">
                            <label class="mb-1 searchIcon-color" for="lastname">Onsite Training</label>
                            <p>{{ editLeadForm.controls['onsite_training_date'].value | date: 'dd/MM/yy' }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['onsite_training_time'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Time</label>
                            <p>{{ editLeadForm.controls['onsite_training_time'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['comments'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Comments</label>
                            <p>{{ editLeadForm.controls['comments'].value ? editLeadForm.controls['comments'].value : '\u00A0' }}</p>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Buyer')">
                        <div class="d-flex align-items-center gap-3 flex-wrap">
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['listing_type'].value">
                            <label class="mb-1 searchIcon-color" for="lastname">Property Type</label>
                            <p>{{ editLeadForm.controls['listing_type'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['price_range'].value">
                            <label class="mb-1 searchIcon-color" for="priceRange">Price Range</label>
                            <p>{{ editLeadForm.controls['price_range'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['beds'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Bedrooms</label>
                            <p>{{ editLeadForm.controls['beds'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['baths'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Bathrooms</label>
                            <p>{{ editLeadForm.controls['baths'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['car'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Car Parks</label>
                            <p>{{ editLeadForm.controls['car'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['age_group'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Age Group</label>
                            <p>{{ editLeadForm.controls['age_group'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['min_land_area'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Land Size</label>
                            <p>{{ editLeadForm.controls['min_land_area'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['max_land_area'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Max</label>
                            <p>{{ editLeadForm.controls['max_land_area'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['established_property'].value">
                            <label class="mb-1 text-nowrap searchIcon-color" for="firstname">New or Established</label>
                            <p>{{ editLeadForm.controls['established_property'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['intended_use'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Intended Use</label>
                            <p>{{ editLeadForm.controls['intended_use'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['time_frame'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Buyer Timeframe</label>
                            <p>{{ editLeadForm.controls['time_frame'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['outdoor_feature'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Outdoor Feature</label>
                            <p>{{ editLeadForm.controls['outdoor_feature'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['indoor_feature'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Indoor Feature</label>
                            <p>{{ editLeadForm.controls['indoor_feature'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['reason_for_buying'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Reason For Buying</label>
                            <p>{{ editLeadForm.controls['reason_for_buying'].value }}</p>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Seller')">
                        <div class="d-flex align-items-center gap-3 flex-wrap">
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['address'].value">
                            <label class="mb-1 searchIcon-color" for="lastname">Address</label>
                            <p>{{ editLeadForm.controls['address'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['listing_type'].value">
                            <label class="mb-1 searchIcon-color" for="lastname">Property Type</label>
                            <p>{{ editLeadForm.controls['listing_type'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['price_range'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Price Range</label>
                            <p>{{ editLeadForm.controls['price_range'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['beds'].value">
                            <label for="firstname" class="mb-1 searchIcon-color">Bedrooms</label>
                            <p>{{ editLeadForm.controls['beds'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['baths'].value">
                            <label for="firstname" class="mb-1 searchIcon-color">Bathrooms</label>
                            <p>{{ editLeadForm.controls['baths'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['car'].value">
                            <label for="firstname" class="mb-1 searchIcon-color">Car Parks</label>
                            <p>{{ editLeadForm.controls['car'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['reason_for_selling'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Reason For Selling</label>
                            <p>{{ editLeadForm.controls['reason_for_selling'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['current_purpose'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Current Purpose</label>
                            <p>{{ editLeadForm.controls['current_purpose'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['time_frame'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Selling Timeframe</label>
                            <p>{{ editLeadForm.controls['time_frame'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['age_group'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Age Group</label>
                            <p>{{ editLeadForm.controls['age_group'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['tenancy_details'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Tenancy Details</label>
                            <p>{{ editLeadForm.controls['tenancy_details'].value }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['tenancy_end_date'].value">
                            <label class="mb-1 searchIcon-color" for="firstname">Tenancy End Date</label>
                            <p>{{ editLeadForm.controls['tenancy_end_date'].value | date: 'dd/MM/yy' }}</p>
                          </div>
                          <div class="d-flex flex-column w-210px" *ngIf="editLeadForm.controls['features'].value">
                            <label class="mb-1 searchIcon-color" for="features">Features</label>
                            <p>{{ editLeadForm.controls['features'].value }}</p>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="editLeadForm.controls['lead_type'].value?.includes('Developer')">
                        <div class="row">
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['development_type'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Development Type</label>
                              <p>{{ editLeadForm.controls['development_type'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['project_address'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Project Address</label>
                              <p>{{ editLeadForm.controls['project_address'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['project_suburb'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Project Suburb</label>
                              <p>{{ editLeadForm.controls['project_suburb'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['project_status'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Project Status</label>
                              <p>{{ editLeadForm.controls['project_status'].value }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['lot_quantity'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Lot Quantity</label>
                              <p>{{ editLeadForm.controls['lot_quantity'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['current_market'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Currently Marketed</label>
                              <p>{{ editLeadForm.controls['current_market'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['product_mix'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Product Mix</label>
                              <p>{{ editLeadForm.controls['product_mix'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['price_range'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Price Range</label>
                              <p>{{ editLeadForm.controls['price_range'].value }}</p>
                            </div>
                          </div>
                        </div>

                        <div class="row mt-3">
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['time_frame'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Timeframe</label>
                              <p>{{ editLeadForm.controls['time_frame'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['levels'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Levels</label>
                              <p>{{ editLeadForm.controls['levels'].value }}</p>
                            </div>
                          </div>
                          <div class="col-sm-3 {{ mobToggle ? 'px-1' : '' }}" *ngIf="editLeadForm.controls['amenities'].value">
                            <div class="form-group mb-2">
                              <label class="mb-1 searchIcon-color" for="firstname">Amenities</label>
                              <p>{{ editLeadForm.controls['amenities'].value }}</p>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-template>
                </app-collapse-box>
              </ng-container>

              <div class="row w-101 equal-height-row d-none">
                <div class="col-sm-6 px-0"></div>
              </div>

              <!-- <app-collapse-box [heading]="isNoteCollapsed ? 'Notes (To Be Completed)' : 'Notes'" [isFromLead]="true"
                [AddNew]="false" [isCollapsed]="isNoteCollapsed" helpTarget="lead-detail-notes">
                <div style="max-height: 300px; overflow: auto">
                  <app-notes [moduleId]="this.lead_detail" (notesList)="notesList($event)" [isView]="!isLeadEdit"
                    [module]="'lead'"></app-notes>
                </div>
              </app-collapse-box> -->

              <app-collapse-box
                [heading]="lead_detail?.emailcontents?.parsed ? 'Enquiry Details' : 'Enquiry Details (To Be Completed)'"
                [isFromLead]="true"
                [AddNew]="false"
                [isCollapsed]="lead_detail?.emailcontents?.parsed ? false : true"
                helpTarget="lead-detail-enquiry-details">
                <div *ngIf="lead_detail?.emailcontents?.parsed; else tpl_manual" class="mb-3 mt-3">
                  <div class="f-14 _fw-600 mb-3">
                    From:
                    {{ lead_detail?.emailcontents?.parsed?.from?.text }}
                    <br />
                    <span class="float-right">
                      {{ lead_detail?.emailcontents?.parsed?.date | date: 'd MMM yy' }}
                    </span>
                  </div>
                  <p class="f-14 _fw-600 mb-2">Subject: {{ lead_detail?.emailcontents?.parsed?.headers?.subject }}</p>
                  <div
                    class="f-14 line-h-1-4"
                    *ngIf="Utils.isHTMLElement(lead_detail?.emailcontents?.parsed?.html)"
                    [innerHTML]="lead_detail?.emailcontents?.parsed?.html"></div>
                  <p class="f-14 line-h-1-4" *ngIf="!Utils.isHTMLElement(lead_detail?.emailcontents?.parsed?.html)">
                    {{ lead_detail?.emailcontents?.parsed?.html }}
                  </p>
                </div>

                <ng-template #tpl_manual>
                  <div class="d-flex w-400px align-items-center flex-wrap text-center">
                    <div>
                      <p>No data, lead added manually.</p>
                    </div>
                  </div>
                </ng-template>
              </app-collapse-box>

              <div class="linked-contacts-row">
                <app-linked-contact-summary
                  *ngIf="lead_detail?.contactid"
                  [contact]="lead_contact"
                  [title]="showLeadBuyer ? 'AGENT' : 'LINKED CONTACT'"
                  [leadId]="lead_detail?._id"
                  [lead]="lead_detail"
                  [canEdit]="isAllowEdit()"
                  [isSaving]="isSavingAlternate"
                  (addAlternate)="addLeadAsAlternate($event)"></app-linked-contact-summary>
                <app-linked-contact-summary *ngIf="showLeadBuyer" [contact]="lead_buyer" [title]="'BUYER'"></app-linked-contact-summary>
              </div>
              <div class="w-100 text-right" helpTarget="lead-detail-contact-actions">
                <div *ngIf="!lead_detail?.contactid">
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-users"
                    helpTarget="lead-detail-convert-contact"
                    (click)="convertToContact(lead_detail, null, false, true)"
                    class="p-button-rounded p-button-secondary p-button-text"
                    pTooltip="Convert to contact"></button>
                </div>
                <ng-container *ngIf="isAllowEdit() && lead_detail?.contactid">
                  <div class="flexCenterEnd">
                    <a
                      href="javascript:void(0)"
                      style="color: #229276"
                      pTooltip="Assigned to {{ lead_detail?.first_name }} {{ lead_detail?.last_name }}"
                      (click)="openContactPopup(false, lead_detail)">
                      {{ lead_detail?.first_name }}
                    </a>
                    <button
                      pButton
                      pRipple
                      type="button"
                      icon="pi pi-user-minus"
                      (click)="removeAssignment()"
                      class="p-button-rounded ml-3 p-button-secondary p-button-text"
                      id="contact_icon"
                      pTooltip="Remove Assigned"></button>
                  </div>
                </ng-container>
              </div>
            </form>
          </div>
        </div>

        <div class="col-sm-3 mb-3 lead-activity-col">
          <div class="activity-box mb-3" helpTarget="lead-detail-activity">
            <p class="f-14 _fw-600 mb-3">ACTIVITY</p>

            <div class="activity-sidebar-tabs-target mb-0" *ngIf="commission_list?.length > 0" helpTarget="lead-detail-activity-tabs">
              <div class="tabs mb-0" *ngIf="commission_list?.length > 0">
                <a [class.active]="_activity === 'status'" (click)="_activity = 'status'">Status</a>
                <a [class.active]="_activity === 'communication'" (click)="_activity = 'communication'">Communication ({{ numberOfRecords }})</a>
              </div>
            </div>

            <ng-container *ngIf="_activity === 'status'; else isCommunication">
              <ng-container *ngFor="let status of leadStatus; let i = index; let islast = last">
                <div class="d-flex {{ status?.changed_on ? ' align-items-start' : ' align-items-center' }} gap-3">
                  <i
                    class="{{ status.icon }} index-activity
                {{ editLeadForm.controls['lead_status'].value == status.tag_name && 'activeTagsIcon' }}"
                    [ngStyle]="{
                      'background-color': editLeadForm.controls['lead_status'].value == status.tag_name ? status?.background_color : '',
                      border: editLeadForm.controls['lead_status'].value == status.tag_name ? '1px solid ' + status?.background_color : '',
                    }"></i>
                  <div class="d-flex flex-column">
                    <p
                      class="{{ editLeadForm.controls['lead_status'].value == status.tag_name ? 'activeTags _fw-600' : 'notActive _fw-400' }}"
                      [class.timeline-status-editable]="isAllowEdit() && editLeadForm.controls['lead_status'].value != status.tag_name"
                      [pTooltip]="
                        isAllowEdit() && editLeadForm.controls['lead_status'].value != status.tag_name ? 'Double Click To Change Status' : ''
                      "
                      tooltipPosition="left"
                      [ngStyle]="{
                        'background-color': editLeadForm.controls['lead_status'].value == status.tag_name ? status?.background_color : '',
                      }"
                      (dblclick)="onTimelineStatusDblClick(status)">
                      {{ status.tag_name }}
                    </p>
                    <div class="timeline-reason-picker mt-2" *ngIf="pendingTimelineStatus?.tag_name === status.tag_name">
                      <ng-select
                        [items]="not_interested_reason"
                        bindLabel="tag_name"
                        [searchable]="true"
                        [clearable]="false"
                        placeholder="Select Reason"
                        appendTo="body"
                        (change)="onTimelineReasonChange($event)">
                        <ng-template ng-option-tmp let-item="item">
                          <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                        </ng-template>
                      </ng-select>
                      <a class="f-10 cp mt-1 d-inline-block" (click)="cancelTimelineStatus()">Cancel</a>
                    </div>
                    <ng-container *ngIf="status?.changed_on">
                      <p class="_fw-400 mt-2 f-10">
                        {{ status?.changed_on | customTimeAgo }} - {{ status?.changed_on | date: 'd MMM, yyyy, h:mm a' }}
                      </p>
                    </ng-container>
                  </div>
                </div>
                <div class="border-between {{ status?.changed_on && 'margin-between10px' }}" *ngIf="!islast"></div>
              </ng-container>
            </ng-container>

            <ng-template #isCommunication>
              <ng-container *ngIf="commissionStats?.length > 0">
                <div class="statas">
                  <div class="position-relative" *ngFor="let item of commissionStats; let i = index">
                    <i
                      class="index-activity pi"
                      tooltipPosition="bottom"
                      pTooltip="{{ commissionChannelDisplayLabel(item?.channel) }}"
                      [ngClass]="commissionChannelPrimeIcon(item?.channel)"></i>
                    <span class="count">{{ item?.count }}</span>
                  </div>
                </div>

                <ng-container *ngFor="let item of commission_list; let i = index; let islast = last">
                  <div class="align-items-start d-flex gap-2" *ngIf="i < loadCom">
                    <i class="index-activity pi" [ngClass]="commissionChannelPrimeIcon(item?.channel)"></i>

                    <div class="d-flex flex-column">
                      <p class="_fw-600" style="padding: 3px 0px">
                        {{ getInitials(item?.user_name) }} -
                        {{ commissionChannelDisplayLabel(item?.channel) }}
                      </p>
                      <p class="_fw-400" style="line-height: 15px; font-size: 10px !important">
                        {{ item?.created_at | customTimeAgo }}
                        <br />
                        {{ item?.created_at | date: 'dd/MM/yy, h:mm a' }}
                      </p>
                    </div>
                  </div>
                  <div class="border-between margin-between" *ngIf="i < loadCom"></div>
                </ng-container>

                <p class="f-12 text-center cp" *ngIf="commission_list?.length > 5" (click)="loadCom === 6 ? (loadCom = 999) : (loadCom = 6)">
                  Load {{ loadCom !== 6 ? 'Less' : 'More' }}
                </p>
              </ng-container>
            </ng-template>
          </div>
          <ng-container *ngFlag="'lead_tags'">
            <div class="row equal-height-row">
              <app-collapse-box
                [heading]="'Tags'"
                [isFromLead]="true"
                [bgwhite]="true"
                [AddNew]="mobToggle == true ? false : true"
                [isCollapsed]="false"
                helpTarget="lead-detail-tags"
                (TriggerAction)="CollapseBoxActionTriggered($event)">
                <div class="lead-left px-0 mb-3">
                  <div class="inner-left">
                    <div
                      cdkDropList
                      #doneList="cdkDropList"
                      [cdkDropListData]="todo"
                      [cdkDropListConnectedTo]="['todoList', 'todoList_2']"
                      (cdkDropListDropped)="dropTag($event)"
                      class="flex_center_wrap tags-container pb-1 border-0">
                      <div
                        class="mr-2 mb-1 f-12 primary-chip cp p-chip d-flex align-items-center"
                        *ngFor="let item of todo; let i = index"
                        tooltipPosition="top"
                        [pTooltip]="item?.type">
                        <div class="p-chip-text">{{ item?.tag_name }}</div>
                        <i class="pi pi-times cp ml-2 mt-3px f-10" *ngIf="isLeadEdit" (click)="removePublicTag(i)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </app-collapse-box>
            </div>
          </ng-container>
          <div class="mt-3 d-flex align-items-center justify-content-between">
            <p>{{ lead_status_type == 'Active' ? 'Active Lead' : lead_status_type }}</p>
            <div class="d-flex align-items-center gap-2">
              <i class="pi pi-calendar f-12"></i>
              <p>{{ createdDate(lead_detail?.created_at) }}</p>
            </div>
          </div>
          <!-- Remmi AI correction indicator: fields auto-corrected once, just after lead creation -->
          <div class="ai-corrected-marker mt-3" *ngIf="hasAiCorrections">
            <span class="ai-corrected-badge lg" [pTooltip]="'Corrected by Remmi AI — ' + aiCorrectedFieldLabels" tooltipPosition="top">
              <i class="pi pi-sparkles"></i> Corrected by Remmi AI
            </span>
          </div>
          <!-- Dynamic CRM sync status badge (project leads on Dynamic-enabled projects only) -->
          <div class="d-flex align-items-center flex-wrap gap-2 dynamic-sync-badge mt-3" *ngIf="isDynamicSyncVisible">
            <!-- Queued -->
            <span
              *ngIf="lead_detail?.dynamic_sync_status === 'pending'"
              class="dynamic-sync-chip ds-pending"
              pTooltip="Queued for Dynamic CRM"
              tooltipPosition="top">
              <i class="pi pi-spin pi-spinner f-12"></i> Dynamic: Queued
            </span>
            <!-- Syncing -->
            <span
              *ngIf="lead_detail?.dynamic_sync_status === 'syncing'"
              class="dynamic-sync-chip ds-syncing"
              pTooltip="Syncing to Dynamic CRM"
              tooltipPosition="top">
              <i class="pi pi-spin pi-spinner f-12"></i> Dynamic: Syncing…
            </span>
            <!-- Synced -->
            <span
              *ngIf="lead_detail?.dynamic_sync_status === 'synced'"
              class="dynamic-sync-chip ds-synced"
              [pTooltip]="
                lead_detail?.dynamic_sync_at ? 'Last synced: ' + (lead_detail?.dynamic_sync_at | date: 'dd/MM/yy h:mm a') : 'Synced to Dynamic CRM'
              "
              tooltipPosition="top">
              <i class="pi pi-check-circle f-12"></i> Dynamic: Synced
            </span>
            <!-- Failed -->
            <ng-container *ngIf="lead_detail?.dynamic_sync_status === 'failed'">
              <span
                class="dynamic-sync-chip ds-failed"
                [pTooltip]="lead_detail?.dynamic_sync_error || 'Sync to Dynamic CRM failed'"
                tooltipPosition="top">
                <i class="pi pi-times-circle f-12"></i> Dynamic: Failed
              </span>
              <span *ngIf="lead_detail?.dynamic_sync_exhausted" class="ds-exhausted f-12">Auto-retry stopped — please retry</span>
              <button
                type="button"
                class="dynamic-sync-retry"
                (click)="retryDynamicSync()"
                [disabled]="dynamicSyncRetrying"
                pTooltip="Re-queue sync to Dynamic CRM"
                tooltipPosition="top">
                <i class="pi pi-refresh f-12" [class.pi-spin]="dynamicSyncRetrying"></i> Retry
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div
      class="tab-pane fade {{ tabIndexValue === 1 ? 'show active' : '' }}"
      helpTarget="lead-detail-tab-appointment"
      [id]="'appointment' + leadTabIndex"
      role="tabpanel"
      [attr.aria-labelledby]="'pills-appointment-tab' + leadTabIndex + '-tab'"
      tabindex="0">
      <ng-container *ngIf="leadTabIndex >= 0 && tabIndexValue == 1">
        <app-edit-lead-appointment helpTarget="lead-detail-appointment-content" [leadDetail]="this.lead_detail"></app-edit-lead-appointment>
      </ng-container>
    </div>

    <div
      class="tab-pane fade {{ tabIndexValue === 2 ? 'show active' : '' }}"
      helpTarget="lead-detail-tab-email"
      [id]="'email' + leadTabIndex"
      role="tabpanel"
      [attr.aria-labelledby]="'pills-email-tab' + leadTabIndex + '-tab'"
      tabindex="0">
      <div class="inner-right-bar" [class.show-inner-rightbar]="showMailBar" helpTarget="lead-detail-email-reader">
        <ng-container *ngIf="isNewMail">
          <div class="lead-compose">
            <div class="lead-compose__card">
              <header class="lead-compose__header" helpTarget="lead-detail-email-compose-header">
                <h5 class="lead-compose__title">Compose Email</h5>
                <button type="button" class="lead-compose__close" (click)="hideMailInner()" aria-label="Close compose">
                  <i class="pi pi-times"></i>
                </button>
              </header>

              <div class="lead-compose__body" helpTarget="lead-detail-email-compose">
                <form [formGroup]="composeEmail" class="lead-compose__form">
                  <div class="lead-compose__field">
                    <label class="lead-compose__label" for="composeTo"> To <span class="lead-compose__required" title="Required">*</span> </label>
                    <p-autoComplete
                      inputId="composeTo"
                      styleClass="lead-compose__autocomplete"
                      placeholder="Add recipients"
                      formControlName="to"
                      field="email"
                      [suggestions]="emailToSuggestion"
                      (completeMethod)="search($event)"
                      [multiple]="true"
                      (onKeyUp)="onKeyUpGetEmailToStatus($event)">
                      <ng-template let-item pTemplate="item">
                        <div class="email-suggestion">
                          <p-avatar
                            *ngIf="item.photo_thumb"
                            image="{{ item.photo_thumb }}"
                            shape="circle"
                            styleClass="email-suggestion__avatar"></p-avatar>

                          <p-avatar
                            *ngIf="!item.photo_thumb"
                            label="{{ suggestionInitials(item) }}"
                            [style]="{
                              'background-color': '#e9f4f1',
                              color: '#1a2f45',
                              border: '1px solid #229276',
                            }"
                            shape="circle"
                            styleClass="email-suggestion__avatar"></p-avatar>

                          <div class="email-suggestion__body">
                            <span class="email-suggestion__name" *ngIf="item?.full_name">{{ item.full_name }}</span>
                            <span class="email-suggestion__email">{{ item?.email }}</span>
                            <span class="email-suggestion__role" *ngIf="item?.role">{{ item.role }}</span>
                          </div>
                        </div>
                      </ng-template>
                    </p-autoComplete>
                    <span
                      class="lead-compose__error"
                      *ngIf="composeEmail.controls['to'].touched && submitEmail && composeEmail.controls['to'].hasError('required')">
                      To is required
                    </span>
                  </div>

                  <div class="lead-compose__field">
                    <label class="lead-compose__label" for="composeSubject">
                      Subject <span class="lead-compose__required" title="Required">*</span>
                    </label>
                    <input id="composeSubject" type="text" class="lead-compose__input" formControlName="subject" placeholder="Subject" />
                    <span
                      class="lead-compose__error"
                      *ngIf="composeEmail.controls['subject'].touched && submitEmail && composeEmail.controls['subject'].hasError('required')">
                      Subject is required
                    </span>
                  </div>

                  <div class="lead-compose__field lead-compose__field--message compose_lead_email">
                    <label class="lead-compose__label"> Message <span class="lead-compose__required" title="Required">*</span> </label>
                    <div class="lead-compose__editor gmail-box">
                      <ckeditor formControlName="message" [editor]="Editor" data="" (ready)="onReady($event)"> </ckeditor>
                    </div>
                    <span
                      class="lead-compose__error"
                      *ngIf="composeEmail.controls['message'].touched && submitEmail && composeEmail.controls['message'].hasError('required')">
                      Message is required
                    </span>
                  </div>
                </form>
              </div>

              <footer class="lead-compose__footer">
                <button type="button" class="_cancel-btn" (click)="hideMailInner()">Cancel</button>
                <button type="button" class="_primary-btn" (click)="sendEmail()">Send</button>
              </footer>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isNewMail">
          <div class="d-flex align-items-center justify-content-between my-2" helpTarget="lead-detail-email-view-actions">
            <h5 class="f-14 text-primary _fw-600">Email Details</h5>
            <div class="d-flex align-items-center">
              <ng-container *ngIf="emailConnected">
                <button
                  *ngIf="mail_detail?.assign_to_leads[0]?.lead_id == this.lead_detail?._id"
                  pTooltip="Unassign to current lead"
                  tooltipPosition="top"
                  [showDelay]="1000"
                  type="button"
                  icon="pi pi-user-minus"
                  (click)="unAssignEmailToSelectedLead(mail_detail)"
                  class="_view-btn f-12 h-auto p-2">
                  <i class="pi pi-user-minus f-12"></i>
                </button>
                <button
                  *ngIf="mail_detail?.assign_to_leads?.length == 0"
                  pTooltip="Assign to lead"
                  tooltipPosition="top"
                  [showDelay]="1000"
                  type="button"
                  icon="pi pi-users"
                  (click)="message_id = mail_detail?.id; assignedEmail.toggle($event)"
                  class="_view-btn f-12 h-auto p-2">
                  <i class="pi pi-users f-12"></i>
                </button>
                <button
                  (click)="markPrivate(mail_detail)"
                  class="ml-2 _view-btn f-12 h-auto p-2"
                  pTooltip="Make it private"
                  tooltipPosition="top"
                  [showDelay]="1000">
                  <i class="pi pi-lock f-12"></i>
                </button>
                <button
                  (click)="showMailInnerReply(true)"
                  class="mx-2 _view-btn f-12 h-auto p-2"
                  pTooltip="Reply"
                  tooltipPosition="top"
                  [showDelay]="1000">
                  <i class="pi pi-reply f-12"></i>
                </button>
              </ng-container>
              <button (click)="hideMailInner()" class="_view-btn f-12 h-auto p-2">
                <i class="pi pi-times f-12"></i>
              </button>
            </div>
          </div>
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-1" *ngIf="fromOrTop == 'from'">
              <p>{{ mail_detail?.from }}</p>
              <p class="f-10" style="color: #5e5e5e">{{ mail_detail?.thread_Date }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-1" *ngIf="fromOrTop == 'to'">
              <p>{{ mail_detail?.to }}</p>
              <p class="f-10" style="color: #5e5e5e">{{ mail_detail?.thread_Date }}</p>
            </div>
            <p class="_fw-400">{{ mail_detail?.subject }}</p>
            <p class="_fw-400" *ngIf="Utils.isHTMLElement(mail_detail?.snippet)" [innerHTML]="mail_detail?.snippet"></p>
            <p class="_fw-400" *ngIf="!Utils.isHTMLElement(mail_detail?.snippet)">
              {{ mail_detail?.snippet }}
            </p>
          </div>
          <hr class="line-style" *ngIf="mail_detail?.thread?.length > 0" />
          <ng-container *ngIf="mail_detail?.thread?.length > 0">
            <div *ngFor="let thread of mail_detail?.thread.slice(0, load_threads); let i = index">
              <ng-container *ngIf="thread?.id !== mail_detail?.id">
                <div class="d-flex align-items-center justify-content-between mb-1">
                  <p class="_fw-600">
                    {{ thread?.labelIds?.includes('SENT') ? thread.from : thread.from }}
                  </p>
                  <p class="f-10" style="color: #5e5e5e">
                    {{ formatDate(thread?.internalDate) }}
                  </p>
                </div>
                <p class="_fw-400">{{ thread?.subject }}</p>
                <p class="_fw-400">{{ thread?.snippet }}</p>
                <hr class="line-style" />
              </ng-container>
            </div>
            <p
              class="count-div"
              (click)="load_threads = load_threads + 3"
              *ngIf="mail_detail?.thread?.length > 2 && mail_detail?.thread?.length > load_threads">
              Load More
            </p>
            <p class="count-div" (click)="load_threads = 2" *ngIf="mail_detail?.thread?.length <= load_threads">Load Less</p>
          </ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="!emailConnected">
        <div class="d-flex w-400px align-items-start mb-3" helpTarget="lead-detail-email-connect">
          <img [src]="email_icon" class="mr-4 email-connect" />
          <div>
            <p class="mb-3 l-h-1-31 {{ mobToggle ? 'f-10' : 'f-14' }}">
              Connect your email to Remmi. You can synchronize messages and link them to your leads and contacts.
            </p>
            <button *ngIf="!emailConnected && !showConnectBtns" class="_primary-btn" (click)="showConnectBtns = true">Connect Your Email</button>
            <ng-container *ngIf="!emailConnected && showConnectBtns">
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" (click)="gSuiteLogin()" class="_primary-btn d-flex align-items-center">G Suite</a>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container>
        <div class="d-flex align-items-center secondary-tabs b-b-tabs" helpTarget="lead-detail-email-inbox-sent-tabs">
          <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
            <li class="nav-item cursor-pointer position-relative" role="presentation" (click)="isInbox = true; isSent = false">
              <a
                class="active"
                [id]="'pills-inbox' + leadTabIndex"
                data-bs-toggle="pill"
                [attr.data-bs-target]="'#inbox' + leadTabIndex"
                role="tab"
                [attr.aria-controls]="'inbox' + leadTabIndex"
                aria-selected="false">
                <i class="f-12 mr-2 pi pi-fw pi-inbox"></i>
                Inbox
              </a>
              <div class="right-boarder"></div>
            </li>
            <li class="nav-item cursor-pointer position-relative" role="presentation" (click)="isSent = true; isInbox = false">
              <a
                class=""
                [id]="'pills-sent' + leadTabIndex"
                data-bs-toggle="pill"
                [attr.data-bs-target]="'#sent' + leadTabIndex"
                role="tab"
                [attr.aria-controls]="'sent' + leadTabIndex"
                aria-selected="false">
                <i class="f-12 mr-2 pi pi-fw pi-send"></i>
                Sent
              </a>
            </li>
          </ul>
        </div>

        <div class="flexCenterEnd my-2" helpTarget="lead-detail-email-list-toolbar">
          <input
            type="text"
            [(ngModel)]="emailKeyword"
            id="emailInput"
            class="site-input w-200px"
            placeholder="Search email"
            (input)="searchEmailByKeyword()" />
          <i class="ml-3 pi pi-refresh f-14 cursor-pointer" (click)="fetchEmails(lead_detail)"></i>
          <button *ngIf="emailConnected" class="_primary-btn" (click)="showMailInner(true)">Compose</button>
        </div>

        <div class="tab-content" id="pills-tabContent" helpTarget="lead-detail-email-tables">
          <div
            class="tab-pane fade show active"
            helpTarget="lead-detail-email-inbox-table"
            [id]="'inbox' + leadTabIndex"
            role="tabpanel"
            [attr.aria-labelledby]="'pills-inbox-tab' + leadTabIndex"
            tabindex="0">
            <ng-container *ngIf="isFetchedEmails">
              <p-table id="apartmentscolumns" [value]="selectedLeadEmails.inbox">
                <ng-template pTemplate="colgroup">
                  <colgroup>
                    <col style="min-width: 150px; width: 150px" />
                    <col style="min-width: 480px; width: 480px" />
                    <col style="min-width: 70px; width: 70px" />
                    <col style="min-width: 65px; width: 65px" />
                  </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th>From</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th *ngIf="emailConnected">Action</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                  <tr
                    *ngIf="
                      (rowData?.assign_to_leads?.length == 0 && (rowData?.similarity == 0.2 || rowData?.similarity > 0.2)) ||
                      rowData?.assign_to_leads[0]?.lead_id == this.lead_detail?._id
                    ">
                    <td
                      style="white-space: pre-wrap; word-wrap: break-word"
                      (click)="mailIndex = i; viewMailDetail(rowData, 'from'); showMailInner(false)"
                      class="pl-3 cursor-pointer">
                      {{ rowData.from }}
                    </td>
                    <td
                      style="white-space: pre-wrap; word-wrap: break-word"
                      (click)="mailIndex = i; viewMailDetail(rowData, 'from'); showMailInner(false)"
                      class="pl-3 cursor-pointer">
                      <b>{{ rowData?.subject?.slice(0, 25) }}</b
                      >&nbsp;-&nbsp;{{ rowData?.snippet?.slice(0, 95) }}
                    </td>
                    <td
                      style="white-space: pre-wrap; word-wrap: break-word"
                      (click)="mailIndex = i; viewMailDetail(rowData, 'from'); showMailInner(false)"
                      class="pl-3 cursor-pointer">
                      {{ rowData?.internalDate }}
                    </td>
                    <td class="pl-3" *ngIf="emailConnected">
                      <button
                        *ngIf="rowData?.assign_to_leads[0]?.lead_id == this.lead_detail?._id"
                        pTooltip="Unassign to current lead"
                        tooltipPosition="top"
                        [showDelay]="1000"
                        type="button"
                        icon="pi pi-user-minus"
                        (click)="unAssignEmailToSelectedLead(rowData)"
                        class="_view-btn f-12 h-auto p-2">
                        <i class="pi pi-user-minus f-12"></i>
                      </button>
                      <button
                        *ngIf="rowData?.assign_to_leads?.length == 0"
                        pTooltip="Assign to lead"
                        tooltipPosition="top"
                        [showDelay]="1000"
                        type="button"
                        icon="pi pi-users"
                        (click)="message_id = rowData?.id; assignedEmail.toggle($event)"
                        class="_view-btn f-12 h-auto p-2">
                        <i class="pi pi-users f-12"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4">{{ 'No email available' }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </ng-container>
          </div>
          <div
            class="tab-pane fade show"
            helpTarget="lead-detail-email-sent-table"
            [id]="'sent' + leadTabIndex"
            role="tabpanel"
            [attr.aria-labelledby]="'pills-sent-tab' + leadTabIndex"
            tabindex="0">
            <ng-container *ngIf="isFetchedEmails">
              <p-table id="apartmentscolumns" [value]="selectedLeadEmails.sent">
                <ng-template pTemplate="colgroup">
                  <colgroup>
                    <col style="min-width: 150px; width: 150px" />
                    <col style="min-width: 480px; width: 480px" />
                    <col style="min-width: 70px; width: 70px" />
                    <col style="min-width: 65px; width: 65px" />
                  </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th>To</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th *ngIf="emailConnected">Action</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                  <tr
                    *ngIf="
                      (rowData?.assign_to_leads?.length == 0 && (rowData?.similarity == 0.2 || rowData?.similarity > 0.2)) ||
                      rowData?.assign_to_leads[0]?.lead_id == this.lead_detail?._id
                    ">
                    <td
                      style="white-space: pre-wrap; word-wrap: break-word"
                      (click)="mailIndex = i; viewMailDetail(rowData, 'from'); showMailInner(false)"
                      class="pl-3 cursor-pointer">
                      {{ rowData.to }}
                    </td>
                    <td
                      style="white-space: pre-wrap; word-wrap: break-word"
                      (click)="mailIndex = i; viewMailDetail(rowData, 'from'); showMailInner(false)"
                      class="pl-3 cursor-pointer">
                      <b>{{ rowData?.subject?.slice(0, 25) }}</b
                      >&nbsp;-&nbsp;{{ rowData?.snippet?.slice(0, 95) }}
                    </td>
                    <td
                      style="white-space: pre-wrap; word-wrap: break-word"
                      (click)="mailIndex = i; viewMailDetail(rowData, 'from'); showMailInner(false)"
                      class="pl-3 cursor-pointer">
                      {{ rowData?.internalDate }}
                    </td>
                    <td class="pl-3" *ngIf="emailConnected">
                      <button
                        *ngIf="rowData?.assign_to_leads[0]?.lead_id == this.lead_detail?._id"
                        pTooltip="Unassign to current lead"
                        tooltipPosition="top"
                        [showDelay]="1000"
                        type="button"
                        icon="pi pi-user-minus"
                        (click)="unAssignEmailToSelectedLead(rowData)"
                        class="_view-btn f-12 h-auto p-2">
                        <i class="pi pi-user-minus f-12"></i>
                      </button>
                      <button
                        *ngIf="rowData?.assign_to_leads?.length == 0"
                        pTooltip="Assign to lead"
                        tooltipPosition="top"
                        [showDelay]="1000"
                        type="button"
                        icon="pi pi-users"
                        (click)="message_id = rowData?.id; assignedEmail.toggle($event)"
                        class="_view-btn f-12 h-auto p-2">
                        <i class="pi pi-users f-12"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4">{{ 'No email available' }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div helpTarget="lead-detail-email-assign-overlay-anchor">
        <p-overlayPanel #assignedEmail [style]="{ width: '350px' }" [dismissable]="true" [showCloseIcon]="true" appendTo="body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group mb-2">
                <ng-select
                  [items]="allAssignedLead"
                  bindLabel="full_name"
                  bindValue="_id"
                  [virtualScroll]="true"
                  [bufferAmount]="10"
                  [searchable]="true"
                  [multiple]="false"
                  class="drop-width"
                  [(ngModel)]="assignedLeadEmail"
                  name="seller"
                  placeholder="Select lead"
                  [clearable]="true"
                  [searchFn]="customFilter">
                  <ng-template ng-option-tmp let-user="item">
                    <div class="d-flex align-items-center justify-content-between">
                      <p>{{ user?.full_name ? user?.full_name : '' }}</p>
                      <p>{{ user?.lead_type ? user?.lead_type : '' }}</p>
                    </div>
                    <p>{{ user?.email ? user?.email : '' }}</p>
                    <p>
                      {{
                        user?.project?.length > 0
                          ? user?.project[0]?.Project_Name
                          : user?.listing?.length > 0
                            ? user?.listing[0]?.property_address
                            : ''
                      }}
                    </p>
                    <div class="d-flex align-items-center justify-content-between">
                      <p>{{ user?.created_at ? user?.created_at : '' }}</p>
                      <p>{{ user?.lead_status ? user?.lead_status : '' }}</p>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="w-100 text-right">
            <button class="_outline-btn mt-3" (click)="assignEmailToSelectedLead(); assignedEmail.hide()">Assign</button>
          </div>
        </p-overlayPanel>
      </div>
    </div>

    <div
      class="tab-pane fade {{ tabIndexValue === 3 ? 'show active' : '' }}"
      helpTarget="lead-detail-tab-sms"
      [id]="'sms' + leadTabIndex"
      role="tabpanel"
      [attr.aria-labelledby]="'pills-sms-tab' + leadTabIndex + '-tab'"
      tabindex="0">
      <ng-container *ngIf="tabIndexValue === 3">
        <div class="lead-sms-panel" helpTarget="lead-detail-sms-panel">
          <div class="lead-sms-toolbar d-flex align-items-center gap-2 mb-3 flex-wrap" helpTarget="lead-detail-sms-toolbar">
            <h5 class="f-14 text-primary _fw-600 mb-0">SMS</h5>
            <span class="lead-sms-badge" *ngIf="smsConversation?.status">{{ smsConversation?.status }}</span>
            <button
              type="button"
              class="_view-btn f-12 h-auto p-2"
              title="Refresh conversation"
              (click)="refreshSmsThread()"
              [disabled]="smsPanelLoading">
              <i class="pi pi-refresh f-14" [class.pi-spin]="smsPanelLoading"></i>
            </button>
          </div>

          <div class="lead-sms-meta lead-sms-meta--inline mb-3" helpTarget="lead-detail-sms-meta" *ngIf="smsConversation">
            <div class="lead-sms-meta-item">
              <p class="f-11 dull mb-0">Opted out</p>
              <p class="f-13 _fw-600 mb-0 text-truncate" title="{{ smsConversation?.opted_out ? 'Yes' : 'No' }}">
                {{ smsConversation?.opted_out ? 'Yes' : 'No' }}
              </p>
            </div>
            <div class="lead-sms-meta-item">
              <p class="f-11 dull mb-0">Manual review</p>
              <p class="f-13 _fw-600 mb-0 text-truncate" title="{{ smsConversation?.manual_review ? 'Yes' : 'No' }}">
                {{ smsConversation?.manual_review ? 'Yes' : 'No' }}
              </p>
            </div>
            <div class="lead-sms-meta-item lead-sms-meta-item--grow">
              <p class="f-11 dull mb-0">Updated</p>
              <p class="f-13 _fw-600 mb-0 text-truncate" [title]="smsConversation?.updated_at ? formatDate(smsConversation.updated_at) : ''">
                {{ smsConversation?.updated_at ? formatDate(smsConversation.updated_at) : '—' }}
              </p>
            </div>
          </div>

          <div class="lead-sms-alert mb-3" *ngIf="smsConversation?.opted_out">
            This lead has opted out of SMS. Sending may fail until they opt back in.
          </div>

          <div class="row g-3 align-items-stretch lead-sms-split">
            <div class="col-4 col-xl-3">
              <div class="lead-sms-compose card-like p-2 h-100 d-flex flex-column" helpTarget="lead-detail-sms-compose">
                <label class="f-12 _fw-600 mb-2 d-block" for="smsBodyInput">Message</label>
                <textarea
                  id="smsBodyInput"
                  class="site-input lead-sms-textarea w-100 lead-sms-textarea--compact"
                  rows="3"
                  [(ngModel)]="smsBody"
                  placeholder="Type your SMS…"
                  [ngModelOptions]="{ standalone: true }"></textarea>
                <div class="d-flex flex-column align-items-stretch gap-2 mt-2">
                  <span class="f-11 dull">{{ (smsBody || '').length }} characters</span>
                  <button
                    type="button"
                    class="_primary-btn align-self-stretch"
                    (click)="sendLeadSms()"
                    [disabled]="smsSendLoading || !smsBody?.trim()">
                    {{ smsSendLoading ? 'Sending…' : 'Send SMS' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-8 col-xl-9">
              <div
                class="lead-sms-thread-wrap card-like h-100 d-flex flex-column overflow-hidden"
                helpTarget="lead-detail-sms-thread"
                *ngIf="!smsPanelLoading; else smsLoadingTpl">
                <div class="lead-sms-thread-head d-flex align-items-center justify-content-between gap-2 px-3 py-2 flex-shrink-0">
                  <span class="f-12 _fw-600 text-secondary">Conversation</span>
                  <span class="f-11 dull" *ngIf="smsMessages?.length"
                    >{{ smsMessages?.length }} message<span *ngIf="smsMessages?.length !== 1">s</span></span
                  >
                </div>
                <div class="lead-sms-thread flex-grow-1">
                  <div class="lead-sms-empty f-13 dull text-center py-5 px-3" *ngIf="smsMessages?.length === 0">
                    <i class="pi pi-comments lead-sms-empty-icon d-block mb-2" aria-hidden="true"></i>
                    No messages yet. Send an SMS from the left to start the thread.
                  </div>
                  <div
                    class="lead-sms-msg"
                    *ngFor="let m of smsMessages"
                    [ngClass]="{ 'lead-sms-msg--out': m?.direction === 'outbound', 'lead-sms-msg--in': m?.direction !== 'outbound' }">
                    <div class="lead-sms-bubble">
                      <p class="lead-sms-bubble-body mb-1" [innerHTML]="smsMessageBodyHtml(m?.body)"></p>
                      <div class="lead-sms-bubble-meta d-flex flex-wrap align-items-center justify-content-between gap-1">
                        <span class="f-10 dull">{{ m?.direction }} · {{ m?.status }}</span>
                        <span class="f-10 dull">{{ m?.created_at ? formatDate(m.created_at) : '' }}</span>
                      </div>
                      <p class="f-11 text-danger mb-0 mt-1" *ngIf="m?.error">{{ m?.error }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #smsLoadingTpl>
                <div class="lead-sms-thread-wrap card-like d-flex align-items-center justify-content-center py-5 h-100">
                  <span class="f-13 dull d-inline-flex align-items-center gap-2">
                    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                    Loading conversation…
                  </span>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div
      class="tab-pane fade {{ tabIndexValue === 4 ? 'show active' : '' }}"
      helpTarget="lead-detail-tab-history"
      [id]="'history' + leadTabIndex"
      role="tabpanel"
      aria-labelledby="pills-history-tab"
      tabindex="0">
      <ng-container *ngIf="tabIndexValue === 4">
        <app-remmi-history helpTarget="lead-detail-history-content" [module]="'Lead'" [record_id]="lead_detail?._id"></app-remmi-history>
      </ng-container>
    </div>

    <div
      class="tab-pane fade {{ tabIndexValue === 5 ? 'show active' : '' }}"
      [id]="'horizon' + leadTabIndex"
      role="tabpanel"
      aria-labelledby="pills-horizon-tab"
      tabindex="0">
      <ng-container *ngIf="tabIndexValue === 5">
        <app-lead-horizon-tracking [leadId]="lead_detail?._id" [projectId]="getLeadProjectId()"></app-lead-horizon-tracking>
      </ng-container>
    </div>
  </div>
</div>

<app-possible-duplicate-contact
  [(visible)]="contactConflict"
  [contacts]="contactList"
  [newContact]="duplicateContactDraft"
  (assign)="convertToContact(lead_detail, $event.contactId, false, true, $event.addAsAlternate, $event.label)"
  (createNew)="convertToContact(lead_detail, null, true, true)"></app-possible-duplicate-contact>
<!-- visible -->
<ng-container *ngIf="visible">
  <div class="custom-modal" helpTarget="lead-detail-modal-related-leads">
    <div class="modal-content">
      <p class="_fw-600 f-18 pl-2 mb-3">Related Leads</p>
      <table class="table mb-0">
        <thead style="border-bottom: 1px solid #e8eaec !important">
          <tr class="f-12">
            <th scope="col text-nowrap" style="border: none">Lead Type</th>
            <th scope="col text-nowrap" style="border: none">Listing / Project</th>
            <th scope="col text-nowrap" style="border: none">Status</th>
            <th scope="col text-nowrap" style="border: none">Agent</th>
            <th scope="col text-nowrap" style="border: none">Status Type</th>
            <th scope="col text-nowrap" style="border: none">Created</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="related_lead?.length > 0">
            <ng-container *ngFor="let lead of related_lead; index as i">
              <tr class="f-14 cursor-pointer" (click)="editRecord(lead, true)">
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.lead_type }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.listing_project?.project || lead?.listing_project?.listing }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.lead_status }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.agent?.full_name }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.status_type }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.created_at | date: 'd/M/yyyy, h:mm a' }}
                  </p>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
      <button (click)="close()" class="popup-close"><i class="pi pi-times f-14"></i></button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="other_lead_visible">
  <div class="custom-modal" helpTarget="lead-detail-modal-other-leads">
    <div class="modal-content">
      <p class="_fw-600 f-18 pl-2 mb-3">Other Lead Enquiries</p>
      <table class="table mb-0">
        <thead style="border-bottom: 1px solid #e8eaec !important">
          <tr class="f-12">
            <th scope="col text-nowrap" style="border: none">Lead Type</th>
            <th scope="col text-nowrap" style="border: none">Listing / Project</th>
            <th scope="col text-nowrap" style="border: none">Status</th>
            <th scope="col text-nowrap" style="border: none">Agent</th>
            <th scope="col text-nowrap" style="border: none">Status Type</th>
            <th scope="col text-nowrap" style="border: none">Created</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="other_leads?.length > 0">
            <ng-container *ngFor="let lead of other_leads; index as i">
              <tr class="f-14 cursor-pointer" (click)="editRecord(lead, true)">
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.lead_type }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.listing_project?.project || lead?.listing_project?.listing }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.lead_status }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.agent_responsible_formatted }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.status_type }}
                  </p>
                </td>
                <td class="text-truncate text-nowrap cursor-pointer">
                  <p>
                    {{ lead?.created_at | date: 'd/M/yyyy, h:mm a' }}
                  </p>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
      <button (click)="other_lead_visible = false" class="popup-close"><i class="pi pi-times f-14"></i></button>
    </div>
  </div>
</ng-container>
<!-- Duplicate Lead Review + Merge -->
<app-duplicate-lead-merge
  [(visible)]="showDuplicateReview"
  [sourceLeadId]="lead_detail?._id"
  [sourceLead]="lead_detail"
  [userTeamIds]="userTeamIds"
  (merged)="onDuplicateMerged($event)"
  (skipped)="onDuplicatesSkipped($event)"></app-duplicate-lead-merge>

<!-- same person prompt enquiry -->
<p-dialog
  position="center"
  helpTarget="lead-detail-dialog-same-person"
  [modal]="true"
  [style]="{ width: '90vw' }"
  [draggable]="false"
  [resizable]="false"
  [autoZIndex]="true"
  [(visible)]="samePersonPrompt"
  [transitionOptions]="'2ms'">
  <ng-template pTemplate="header">
    <h5>This person has also enquired about another project/property.</h5>
  </ng-template>
  <div class="col-md-12">
    <div *ngIf="samePersonPromptData.length > 0">
      <p-table
        id="samepersondatalist"
        [value]="samePersonPromptData"
        styleClass="p-datatable-striped"
        dataKey="_id"
        [rowHover]="false"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="false"
        currentPageReportTemplate="Results: {first} - {last} of {totalRecords}"
        [customSort]="true"
        [scrollable]="samePersonPromptData.length > 4 ? true : false"
        scrollHeight="30vh">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 8rem; padding: 10px 5px 10px 0px !important">First name</th>
            <th style="width: 8rem; padding: 10px 5px 10px 0px !important">Last name</th>
            <th style="width: 15rem; padding: 10px 5px 10px 0px !important">Email</th>
            <th style="width: 8rem; padding: 10px 5px 10px 0px !important">Project</th>
            <th style="width: 8rem; padding: 10px 5px 10px 0px !important">Property</th>
            <th style="width: 15rem; padding: 10px 5px 10px 0px !important">Agent Responsible</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-lead>
          <tr>
            <td style="width: 8rem; padding: 10px 5px 10px 0px !important" class="word-break-all">
              {{ lead.first_name }}
            </td>
            <td style="width: 8rem; padding: 10px 5px 10px 0px !important" class="word-break-all">
              {{ lead.last_name }}
            </td>
            <td style="width: 15rem; padding: 10px 5px 10px 0px !important" class="word-break-all">
              {{ lead.email }}
            </td>
            <td style="width: 15rem; padding: 10px 5px 10px 0px !important">{{ lead.project }}</td>
            <td style="width: 8rem; padding: 10px 5px 10px 0px !important">{{ lead.property }}</td>
            <td style="width: 8rem; padding: 10px 5px 10px 0px !important">
              {{ lead.agent_responsible }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">No record found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>
<!-- tags -->
<p-dialog
  [styleClass]="'noHeader'"
  [showHeader]="false"
  helpTarget="lead-detail-dialog-tag-manager"
  [(visible)]="lmService.tag_manager"
  [style]="{ width: '350px' }"
  [position]="'right'"
  styleClass="tag-sidebar-manager">
  <div class="px-2 py-2">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="f-18">Tag Manager</h3>
      <div class="d-flex">
        <button class="_view-btn p-2 h-auto" type="button" (click)="new_tag_popup = true">
          <i class="pi pi-plus f-12"></i>
        </button>
        <button class="ml-3 _view-btn p-2 h-auto" type="button" (click)="closeTagManger()">
          <i class="pi pi-times f-12"></i>
        </button>
      </div>
    </div>
    <div class="mb-4">
      <div class="w-100 my-2 mr-3 position-relative with-right-icon" style="min-width: 230px">
        <input class="site-input" type="text" #searchKeyword [(ngModel)]="keyword_tags" placeholder="Search Tags" (input)="filterItem()" />
        <i class="pi pi-search cp" *ngIf="!keyword_tags" style="top: 11px; font-size: 16px !important"></i>
        <i class="pi pi-times cp" *ngIf="keyword_tags" style="top: 11px; font-size: 16px !important" (click)="resetTagSearch()"></i>
      </div>
    </div>

    <div class="overflow-tags" *ngFor="let status of tagsList; let i = index">
      <ng-container *ngFor="let type of status?.types; let ind = index">
        <div *ngIf="type?._id !== 'createnew'" class="mr-2">
          <div class="box-header mt-2" (click)="toggleBox(type)">
            <p>{{ type.name }}</p>
            <i class="pi f-12" [ngClass]="{ 'pi-minus': type.isOpen, 'pi-plus': !type.isOpen }"></i>
          </div>
          <div class="box-content" [hidden]="!type.isOpen">
            <div class="d-flex flex-wrap" cdkDropList [cdkDropListData]="type?.data" [cdkDropListConnectedTo]="[doneList]">
              <div *ngFor="let tag of type?.data; let j = index" cdkDrag>
                <div
                  class="d-flex align-items-center mt-2 tag-dev mr-2 cursor-pointer"
                  (dblclick)="addTagInForm(0, tag)"
                  pTooltip="Double click to add"
                  tooltipPosition="top">
                  <p class="p-chip-text">{{ tag?.tag_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>
<!-- Tag Type -->
<p-dialog
  [(visible)]="new_tagType_popup"
  helpTarget="lead-detail-dialog-tag-type"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div>
    <div>
      <div class="mt-2">
        <label class="mb-1" class="mb-1">Tag Type</label>
        <input type="text" placeholder="Tag type name" [(ngModel)]="tag_type" class="site-input" />
      </div>
    </div>

    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="tag_type = null; new_tagType_popup = false">Cancel</button>
      <button class="_outline-btn" [class.disabled]="!tag_type" (click)="createTagType()">Add</button>
    </div>
  </div>
</p-dialog>
<!-- New tag -->
<p-dialog
  [(visible)]="new_tag_popup"
  helpTarget="lead-detail-dialog-new-tag"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div class="p-2">
    <div>
      <div class="mt-2">
        <label class="mb-1" class="mb-1 px-1"> Tag Type </label>
        <div class="dropdown-with-create-new" *ngIf="tagsList.length > 0">
          <ng-select
            [items]="tagsList?.[0]?.types"
            bindLabel="name"
            bindValue="_id"
            [(ngModel)]="tag_type"
            placeholder="Select Tag Type"
            [clearable]="true"
            (change)="isNewTypeModel($event)">
          </ng-select>
          <p class="px-1 mt-1 f-10">Select a module to see its tag types</p>
        </div>
      </div>

      <div class="mt-2 chips-custom">
        <label class="mb-1" class="mb-1 px-1">Tags* </label>
        <div class="cs-input-chip">
          <p-chips [(ngModel)]="new_tag" placeholder="Add Multiple Tags" styleClass="w-100" (onAdd)="pushTagToArray($event)"></p-chips>
          <p class="px-1 mt-1 f-10">Press enter after typing tag name</p>
        </div>
      </div>
    </div>
    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="module_type = null; new_tag = []; tag_type = null; new_tag_popup = false">Cancel</button>

      <button class="preview-btn" [class.disabled]="!new_tag?.length || loading || !tag_type?.length" (click)="createTag()">Add</button>
    </div>
  </div>
</p-dialog>

<!-- REM-3537: why a move to No Response was refused — contact attempts so far and the missing follow-up. -->
<app-no-response-blocked-dialog
  [(visible)]="showNoResponseBlock"
  [blockedStatus]="noResponseBlock?.blockedStatus"
  [keptStatus]="noResponseBlock?.keptStatus"
  [requirement]="noResponseBlock?.requirement"
  [timerOptions]="timer_options"
  [canAddFollowUp]="canAddNoResponseFollowUp"
  [isFollowUpSaving]="isNoResponseFollowUpSaving"
  [bookedFollowUpLabel]="noResponseFollowUpLabel"
  (addFollowUp)="addNoResponseFollowUp($event)"></app-no-response-blocked-dialog>

<!-- Help drawer removed with the toolbar's help button — Remmi AI covers this now. The component
     still carries `helpDrawerOpen` if it needs to come back. -->
